webpackJsonp([23,21],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vuexRouterSync = __webpack_require__(1192);
	
	var _vue = __webpack_require__(21);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _elementUi = __webpack_require__(773);
	
	var _elementUi2 = _interopRequireDefault(_elementUi);
	
	var _en = __webpack_require__(245);
	
	var _en2 = _interopRequireDefault(_en);
	
	var _Root = __webpack_require__(917);
	
	var _Root2 = _interopRequireDefault(_Root);
	
	var _vuex = __webpack_require__(6);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _vuexI18n = __webpack_require__(586);
	
	var _vuexI18n2 = _interopRequireDefault(_vuexI18n);
	
	var _lang = __webpack_require__(450);
	
	var _lang2 = _interopRequireDefault(_lang);
	
	var _validations = __webpack_require__(451);
	
	var _validations2 = _interopRequireDefault(_validations);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _veeValidate = __webpack_require__(191);
	
	var _veeValidate2 = _interopRequireDefault(_veeValidate);
	
	var _vueFroalaWysiwyg = __webpack_require__(914);
	
	var _vueFroalaWysiwyg2 = _interopRequireDefault(_vueFroalaWysiwyg);
	
	var _vueSelect = __webpack_require__(1189);
	
	var _vueSelect2 = _interopRequireDefault(_vueSelect);
	
	var _vueJsToggleButton = __webpack_require__(916);
	
	var _vueJsToggleButton2 = _interopRequireDefault(_vueJsToggleButton);
	
	var _store = __webpack_require__(220);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _router = __webpack_require__(631);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _http = __webpack_require__(5);
	
	var _http2 = _interopRequireDefault(_http);
	
	var _eventbus = __webpack_require__(628);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _config = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Lang = 'en';
	
	__webpack_require__(627);
	
	__webpack_require__(625);
	__webpack_require__(626);
	
	_vue2.default.use(_http2.default, { store: _store2.default, router: _router2.default });
	
	window.baseUrl = _config.apiUrl;
	
	_vue2.default.use(_eventbus2.default);
	
	(0, _vuexRouterSync.sync)(_store2.default, _router2.default);
	var hf = new _vuex2.default.Store({
	  modules: {
	    i18n: _vuexI18n2.default.store
	  }
	});
	
	_vue2.default.use(_vueJsToggleButton2.default);
	_vue2.default.use(_vueFroalaWysiwyg2.default);
	
	_vue2.default.directive('focus', {
	  inserted: function inserted(el) {
	    el.focus();
	  }
	});
	
	var numeral = __webpack_require__(895);
	
	_vue2.default.filter("formatNumber", function (value) {
	  return numeral(value).format("0,0");
	});
	
	_vue2.default.use(_vuexI18n2.default.plugin, hf);
	_vue2.default.i18n.add('en', _lang2.default.en);
	
	_vue2.default.i18n.set(Lang);
	(0, _moment2.default)().locale(Lang);
	
	_vue2.default.use(_elementUi2.default, { locale: _en2.default });
	
	_vue2.default.use(_veeValidate2.default, { locale: Lang, events: 'blur' });
	
	var infiniteScroll = __webpack_require__(915);
	_vue2.default.use(infiniteScroll);
	
	_vue2.default.config.lang = Lang;
	
	
	_vue2.default.component('v-select', _vueSelect2.default);
	
	var VueTruncate = __webpack_require__(1191);
	_vue2.default.use(VueTruncate);
	
	new _vue2.default({
	  store: _store2.default,
	  router: _router2.default,
	  el: '#app',
	  render: function render(h) {
	    return h(_Root2.default);
	  }
	});

/***/ }),

/***/ 4:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var apiUrl = exports.apiUrl = ("https://api2.citizenfirewall.in/internal/v1");
	var version = exports.version = ("4.1.2");
	var cdnDomain = exports.cdnDomain = ("https://cdn.humanriskprotection.org");
	var termsLink = exports.termsLink = ("https://www.humanfirewall.io/terms.html");
	var policyLink = exports.policyLink = ("https://www.humanfirewall.io/privacy-policy.html");
	var educationLink = exports.educationLink = ("https://educate2.citizenfirewall.in/");
	var remediatorLink = exports.remediatorLink = ("https://139.59.82.8/api/v1/office/");
	var appUrl = exports.appUrl = ("https://app2.citizenfirewall.in/");
	var mainDomain = exports.mainDomain = ("citizenfirewall.in");
	
	var userTokenStorageKey = exports.userTokenStorageKey = 'APP_USER_TOKEN';

/***/ }),

/***/ 5:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.http = undefined;
	exports.setToken = setToken;
	exports.default = install;
	
	var _axios = __webpack_require__(61);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _interceptors = __webpack_require__(629);
	
	var _interceptors2 = _interopRequireDefault(_interceptors);
	
	var _config = __webpack_require__(4);
	
	var _localforage = __webpack_require__(187);
	
	var _localforage2 = _interopRequireDefault(_localforage);
	
	var _lodash = __webpack_require__(11);
	
	var _config2 = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_axios2.default.interceptors.request.use(function (config) {
	  if (typeof window !== 'undefined' && window.location) {
	    var currentPath = window.location.pathname || '/';
	    var fullUrl = window.location.origin + currentPath;
	    if (config.headers && typeof config.headers.set === 'function') {
	      config.headers.set('X-Page-URL', fullUrl);
	    } else if (config.headers) {
	      config.headers['X-Page-URL'] = fullUrl;
	    } else {
	      config.headers = { 'X-Page-URL': fullUrl };
	    }
	  }
	  return config;
	});
	
	var http = exports.http = _axios2.default.create({
	  baseURL: _config.apiUrl
	});
	
	for (var key in _axios2.default) {
	  if (typeof _axios2.default[key] === 'function') {
	    http[key] = _axios2.default[key].bind(http);
	  } else {
	    http[key] = _axios2.default[key];
	  }
	}
	
	http.defaults.baseURL = _config.apiUrl;
	http.CancelToken = _axios2.default.CancelToken;
	http.isCancel = _axios2.default.isCancel;
	
	if (!http.defaults.headers) {
	  http.defaults.headers = {};
	}
	if (!http.defaults.headers.common) {
	  http.defaults.headers.common = {};
	}
	http.defaults.headers.post = http.defaults.headers.post || {};
	http.defaults.headers.post['Content-Type'] = 'application/json';
	
	function setToken(token) {
	  http.defaults.headers.common.Authorization = 'Bearer ' + token;
	}
	
	function install(Vue, _ref) {
	  var store = _ref.store,
	      router = _ref.router;
	
	
	  (0, _interceptors2.default)(http, store, router);
	
	  Object.defineProperty(Vue.prototype, '$http', {
	    get: function get() {
	      return http;
	    }
	  });
	}

/***/ }),

/***/ 15:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getData = undefined;
	
	var _lodash = __webpack_require__(11);
	
	var getData = exports.getData = function getData(obj) {
	  return (0, _lodash.get)(obj, 'data');
	};

/***/ }),

/***/ 142:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.checkCompanyLicense = exports.revokeToken = exports.loadUserData = exports.postVerification = exports.postRegister = exports.postLearningLogin = exports.postByEmailLinkLogin = exports.postLogin = undefined;
	
	var _objectDestructuringEmpty2 = __webpack_require__(645);
	
	var _objectDestructuringEmpty3 = _interopRequireDefault(_objectDestructuringEmpty2);
	
	var _http = __webpack_require__(5);
	
	var _get = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var postLogin = exports.postLogin = function postLogin(_ref) {
	  var email = _ref.email,
	      password = _ref.password;
	  return _http.http.post('/auth/login', { email: email, password: password }).then(_get.getData);
	};var postByEmailLinkLogin = exports.postByEmailLinkLogin = function postByEmailLinkLogin(_ref2) {
	  (0, _objectDestructuringEmpty3.default)(_ref2);
	  return _http.http.post('/auth/loginbyemail/'.target, {}).then(_get.getData);
	};var postLearningLogin = exports.postLearningLogin = function postLearningLogin(_ref3) {
	  var email = _ref3.email,
	      target = _ref3.target;
	  return _http.http.post('/auth/learning/login', { email: email, target: target }).then(_get.getData);
	};var postRegister = exports.postRegister = function postRegister(_ref4) {
	  var first_name = _ref4.first_name,
	      last_name = _ref4.last_name,
	      designation = _ref4.designation,
	      company = _ref4.company,
	      employee_count = _ref4.employee_count,
	      country = _ref4.country,
	      timezone = _ref4.timezone,
	      email = _ref4.email,
	      password = _ref4.password;
	  return _http.http.post('/auth/register', { first_name: first_name, last_name: last_name, designation: designation, company: company, employee_count: employee_count, country: country, timezone: timezone, email: email, password: password }).then(_get.getData);
	};var postVerification = exports.postVerification = function postVerification(_ref5) {
	  var id = _ref5.id,
	      token = _ref5.token,
	      secret = _ref5.secret;
	  return _http.http.post('/auth/verify', { id: id, token: token, secret: secret }).then(_get.getData);
	};
	
	var loadUserData = exports.loadUserData = function loadUserData() {
	  return _http.http.get('/me').then(_get.getData);
	};
	
	var revokeToken = exports.revokeToken = function revokeToken() {
	  return _http.http.post('/auth/token/revoke').then(_get.getData);
	};
	
	var checkCompanyLicense = exports.checkCompanyLicense = function checkCompanyLicense(token) {
	  return _http.http.post('/auth/validatelic', { 'token': token }).then(_get.getData);
	};

/***/ }),

/***/ 143:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var SET_TOKEN = exports.SET_TOKEN = 'Auth//SET_TOKEN';
	var SET_USER = exports.SET_USER = 'Auth//SET_USER';

/***/ }),

/***/ 145:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(624);
	
	Object.defineProperty(exports, 'vuex', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_vuex).default;
	  }
	});
	
	var _routes = __webpack_require__(620);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 146:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  messages: {
	    success: '',
	    error: {},
	    warning: '',
	    validation: {}
	  },
	  fetching: false
	};

/***/ }),

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(589);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});
	
	var _vuex = __webpack_require__(592);
	
	Object.defineProperty(exports, 'vuex', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_vuex).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 207:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(596);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 208:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(597);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(598);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});
	
	var _vuex = __webpack_require__(601);
	
	Object.defineProperty(exports, 'vuex', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_vuex).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getCompanySubOrg = exports.deleteDomain = exports.verifyTxtRecord = exports.verifyNewDomain = exports.updateDomainData = exports.addNewDomain = exports.geteditDomains = exports.getDomains = undefined;
	
	var _http = __webpack_require__(5);
	
	var _get = __webpack_require__(15);
	
	var getDomains = exports.getDomains = function getDomains(id) {
	  return _http.http.get('/companies/domains/listing?company=' + id).then(_get.getData);
	};
	
	var geteditDomains = exports.geteditDomains = function geteditDomains(id) {
	  return _http.http.get('/companies/domains/edit/' + id).then(_get.getData);
	};
	
	var addNewDomain = exports.addNewDomain = function addNewDomain(_ref) {
	  var name = _ref.name,
	      comp_id = _ref.comp_id;
	  return _http.http.post('/companies/domains', { name: name, comp_id: comp_id }).then(_get.getData);
	};
	var updateDomainData = exports.updateDomainData = function updateDomainData(_ref2) {
	  var id = _ref2.id,
	      comp_id = _ref2.comp_id;
	  return _http.http.post('/companies/domains/update', { id: id, comp_id: comp_id }).then(_get.getData);
	};
	
	var verifyNewDomain = exports.verifyNewDomain = function verifyNewDomain(_ref3) {
	  var id = _ref3.id;
	  return _http.http.post('/companies/domains/verify', { id: id }).then(_get.getData);
	};
	
	var verifyTxtRecord = exports.verifyTxtRecord = function verifyTxtRecord(_ref4) {
	  var id = _ref4.id;
	  return _http.http.post('/companies/domains/verifytxtrecord', { id: id }).then(_get.getData);
	};
	
	var deleteDomain = exports.deleteDomain = function deleteDomain(_ref5) {
	  var id = _ref5.id;
	  return _http.http.delete('/companies/domains/' + id).then(_get.getData);
	};
	
	var getCompanySubOrg = exports.getCompanySubOrg = function getCompanySubOrg() {
	  return _http.http.get('/reports/company/suborg').then(_get.getData);
	};

/***/ }),

/***/ 211:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var SET_DOMAIN_LIST = exports.SET_DOMAIN_LIST = 'Company//SET_DOMAIN_LIST';

/***/ }),

/***/ 212:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(146);
	
	var _state2 = _interopRequireDefault(_state);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  domains: [],
	  messages: _state2.default.messages
	};

/***/ }),

/***/ 213:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(603);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 217:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(617);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(619);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 219:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(623);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 220:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(21);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(6);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _state = __webpack_require__(146);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(635);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	var _actions = __webpack_require__(632);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _modules = __webpack_require__(634);
	
	var _modules2 = _interopRequireDefault(_modules);
	
	var _plugins = __webpack_require__(636);
	
	var _plugins2 = _interopRequireDefault(_plugins);
	
	var _getters = __webpack_require__(633);
	
	var getters = _interopRequireWildcard(_getters);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	exports.default = new _vuex2.default.Store({
	  state: _state2.default,
	  mutations: _mutations2.default,
	  actions: _actions2.default,
	  modules: _modules2.default,
	  plugins: _plugins2.default,
	  getters: getters,
	  strict: ("production") !== 'production'
	});

/***/ }),

/***/ 221:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var MAIN_SET_MESSAGE = exports.MAIN_SET_MESSAGE = 'MAIN_SET_MESSAGE';
	var MAIN_SET_FETCHING = exports.MAIN_SET_FETCHING = 'MAIN_SET_FETCHING';
	
	var CATEGORIES_SET_DATA = exports.CATEGORIES_SET_DATA = 'CATEGORIES_SET_DATA';
	var PRODUCTS_SET_DATA = exports.PRODUCTS_SET_DATA = 'PRODUCTS_SET_DATA';

/***/ }),

/***/ 270:
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 271,
		"./af.js": 271,
		"./ar": 278,
		"./ar-dz": 272,
		"./ar-dz.js": 272,
		"./ar-kw": 273,
		"./ar-kw.js": 273,
		"./ar-ly": 274,
		"./ar-ly.js": 274,
		"./ar-ma": 275,
		"./ar-ma.js": 275,
		"./ar-sa": 276,
		"./ar-sa.js": 276,
		"./ar-tn": 277,
		"./ar-tn.js": 277,
		"./ar.js": 278,
		"./az": 279,
		"./az.js": 279,
		"./be": 280,
		"./be.js": 280,
		"./bg": 281,
		"./bg.js": 281,
		"./bm": 282,
		"./bm.js": 282,
		"./bn": 283,
		"./bn.js": 283,
		"./bo": 284,
		"./bo.js": 284,
		"./br": 285,
		"./br.js": 285,
		"./bs": 286,
		"./bs.js": 286,
		"./ca": 287,
		"./ca.js": 287,
		"./cs": 288,
		"./cs.js": 288,
		"./cv": 289,
		"./cv.js": 289,
		"./cy": 290,
		"./cy.js": 290,
		"./da": 291,
		"./da.js": 291,
		"./de": 294,
		"./de-at": 292,
		"./de-at.js": 292,
		"./de-ch": 293,
		"./de-ch.js": 293,
		"./de.js": 294,
		"./dv": 295,
		"./dv.js": 295,
		"./el": 296,
		"./el.js": 296,
		"./en-au": 297,
		"./en-au.js": 297,
		"./en-ca": 298,
		"./en-ca.js": 298,
		"./en-gb": 299,
		"./en-gb.js": 299,
		"./en-ie": 300,
		"./en-ie.js": 300,
		"./en-nz": 301,
		"./en-nz.js": 301,
		"./eo": 302,
		"./eo.js": 302,
		"./es": 305,
		"./es-do": 303,
		"./es-do.js": 303,
		"./es-us": 304,
		"./es-us.js": 304,
		"./es.js": 305,
		"./et": 306,
		"./et.js": 306,
		"./eu": 307,
		"./eu.js": 307,
		"./fa": 308,
		"./fa.js": 308,
		"./fi": 309,
		"./fi.js": 309,
		"./fo": 310,
		"./fo.js": 310,
		"./fr": 313,
		"./fr-ca": 311,
		"./fr-ca.js": 311,
		"./fr-ch": 312,
		"./fr-ch.js": 312,
		"./fr.js": 313,
		"./fy": 314,
		"./fy.js": 314,
		"./gd": 315,
		"./gd.js": 315,
		"./gl": 316,
		"./gl.js": 316,
		"./gom-latn": 317,
		"./gom-latn.js": 317,
		"./gu": 318,
		"./gu.js": 318,
		"./he": 319,
		"./he.js": 319,
		"./hi": 320,
		"./hi.js": 320,
		"./hr": 321,
		"./hr.js": 321,
		"./hu": 322,
		"./hu.js": 322,
		"./hy-am": 323,
		"./hy-am.js": 323,
		"./id": 324,
		"./id.js": 324,
		"./is": 325,
		"./is.js": 325,
		"./it": 326,
		"./it.js": 326,
		"./ja": 327,
		"./ja.js": 327,
		"./jv": 328,
		"./jv.js": 328,
		"./ka": 329,
		"./ka.js": 329,
		"./kk": 330,
		"./kk.js": 330,
		"./km": 331,
		"./km.js": 331,
		"./kn": 332,
		"./kn.js": 332,
		"./ko": 333,
		"./ko.js": 333,
		"./ky": 334,
		"./ky.js": 334,
		"./lb": 335,
		"./lb.js": 335,
		"./lo": 336,
		"./lo.js": 336,
		"./lt": 337,
		"./lt.js": 337,
		"./lv": 338,
		"./lv.js": 338,
		"./me": 339,
		"./me.js": 339,
		"./mi": 340,
		"./mi.js": 340,
		"./mk": 341,
		"./mk.js": 341,
		"./ml": 342,
		"./ml.js": 342,
		"./mr": 343,
		"./mr.js": 343,
		"./ms": 345,
		"./ms-my": 344,
		"./ms-my.js": 344,
		"./ms.js": 345,
		"./my": 346,
		"./my.js": 346,
		"./nb": 347,
		"./nb.js": 347,
		"./ne": 348,
		"./ne.js": 348,
		"./nl": 350,
		"./nl-be": 349,
		"./nl-be.js": 349,
		"./nl.js": 350,
		"./nn": 351,
		"./nn.js": 351,
		"./pa-in": 352,
		"./pa-in.js": 352,
		"./pl": 353,
		"./pl.js": 353,
		"./pt": 355,
		"./pt-br": 354,
		"./pt-br.js": 354,
		"./pt.js": 355,
		"./ro": 356,
		"./ro.js": 356,
		"./ru": 357,
		"./ru.js": 357,
		"./sd": 358,
		"./sd.js": 358,
		"./se": 359,
		"./se.js": 359,
		"./si": 360,
		"./si.js": 360,
		"./sk": 361,
		"./sk.js": 361,
		"./sl": 362,
		"./sl.js": 362,
		"./sq": 363,
		"./sq.js": 363,
		"./sr": 365,
		"./sr-cyrl": 364,
		"./sr-cyrl.js": 364,
		"./sr.js": 365,
		"./ss": 366,
		"./ss.js": 366,
		"./sv": 367,
		"./sv.js": 367,
		"./sw": 368,
		"./sw.js": 368,
		"./ta": 369,
		"./ta.js": 369,
		"./te": 370,
		"./te.js": 370,
		"./tet": 371,
		"./tet.js": 371,
		"./th": 372,
		"./th.js": 372,
		"./tl-ph": 373,
		"./tl-ph.js": 373,
		"./tlh": 374,
		"./tlh.js": 374,
		"./tr": 375,
		"./tr.js": 375,
		"./tzl": 376,
		"./tzl.js": 376,
		"./tzm": 378,
		"./tzm-latn": 377,
		"./tzm-latn.js": 377,
		"./tzm.js": 378,
		"./uk": 379,
		"./uk.js": 379,
		"./ur": 380,
		"./ur.js": 380,
		"./uz": 382,
		"./uz-latn": 381,
		"./uz-latn.js": 381,
		"./uz.js": 382,
		"./vi": 383,
		"./vi.js": 383,
		"./x-pseudo": 384,
		"./x-pseudo.js": 384,
		"./yo": 385,
		"./yo.js": 385,
		"./zh-cn": 386,
		"./zh-cn.js": 386,
		"./zh-hk": 387,
		"./zh-hk.js": 387,
		"./zh-tw": 388,
		"./zh-tw.js": 388
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 270;


/***/ }),

/***/ 448:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    auth: __webpack_require__(864),
	    recipient: __webpack_require__(868),
	    company: __webpack_require__(866),
	    campaign: __webpack_require__(865),
	    report: __webpack_require__(869),
	    leaderboard: __webpack_require__(867)
	
	};

/***/ }),

/***/ 449:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  messages: {
	    alpha_spaces: function alpha_spaces() {
	      return 'Only alphabets and spaces are allowed.';
	    }
	  },
	  attributes: {
	    first_name: 'first name',
	    last_name: 'last name',
	    designation: 'Job title ',
	    company: 'organisation ',
	    employ_count: 'employee number',
	    confirm_password: 're-type password',
	    agree: 'agree to the terms of service and privacy policy'
	  }
	};

/***/ }),

/***/ 450:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    en: __webpack_require__(448).default
	};

/***/ }),

/***/ 451:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    en: __webpack_require__(449).default
	};

/***/ }),

/***/ 452:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'HumanFirewall'
	};
	
	
	if (!String.prototype.includes) {
	  String.prototype.includes = function (search, start) {
	    'use strict';
	
	    if (search instanceof RegExp) {
	      throw TypeError('first argument must not be a RegExp');
	    }
	    if (start === undefined) {
	      start = 0;
	    }
	    return this.indexOf(search, start) !== -1;
	  };
	}
	
	if (!Array.prototype.includes) {
	  Object.defineProperty(Array.prototype, 'includes', {
	    value: function value(searchElement, fromIndex) {
	
	      if (this == null) {
	        throw new TypeError('"this" is null or not defined');
	      }
	
	      var o = Object(this);
	
	      var len = o.length >>> 0;
	
	      if (len === 0) {
	        return false;
	      }
	
	      var n = fromIndex | 0;
	
	      var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);
	
	      function sameValueZero(x, y) {
	        return x === y || typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y);
	      }
	
	      while (k < len) {
	        if (sameValueZero(o[k], searchElement)) {
	          return true;
	        }
	
	        k++;
	      }
	
	      return false;
	    }
	  });
	
	  if (!Array.prototype.every) {
	    Array.prototype.every = function (callbackfn, thisArg) {
	      'use strict';
	
	      var T, k;
	
	      if (this == null) {
	        throw new TypeError('this is null or not defined');
	      }
	
	      var O = Object(this);
	
	      var len = O.length >>> 0;
	
	      if (typeof callbackfn !== 'function' && Object.prototype.toString.call(callbackfn) !== '[object Function]') {
	        throw new TypeError();
	      }
	
	      if (arguments.length > 1) {
	        T = thisArg;
	      }
	
	      k = 0;
	
	      while (k < len) {
	
	        var kValue;
	
	        if (k in O) {
	          var testResult;
	
	          kValue = O[k];
	
	          if (T) testResult = callbackfn.call(T, kValue, k, O);else testResult = callbackfn(kValue, k, O);
	
	          if (!testResult) {
	            return false;
	          }
	        }
	        k++;
	      }
	      return true;
	    };
	  }
	}

/***/ }),

/***/ 581:
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {};

/***/ }),

/***/ 582:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof2 = __webpack_require__(44);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _extends2 = __webpack_require__(24);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _lodash = __webpack_require__(11);
	
	var _vuex = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    props: {
	        show: {
	            type: Array,
	            default: function _default() {
	                return [];
	            }
	        }
	    },
	    computed: (0, _extends3.default)({}, (0, _vuex.mapState)(['messages']), {
	        hasSuccessMessage: function hasSuccessMessage() {
	            return this.messages.success !== '';
	        },
	        hasErrorMessages: function hasErrorMessages() {
	            return this.show.hasOwnProperty('errors') && (0, _typeof3.default)(this.messages.error) === 'object' && this.messages.error.length > 0;
	        },
	        hasWarningMessages: function hasWarningMessages() {
	            return this.messages.warning !== '';
	        },
	        hasValidationMessages: function hasValidationMessages() {
	            return this.messages.validation.length > 0;
	        },
	        formatedErrorMessage: function formatedErrorMessage() {
	            return (0, _lodash.flatMapDeep)(this.messages.error).map(function (msg) {
	                return '\u2022 ' + msg;
	            }).join('<br>');
	        },
	        formatedValidationMessage: function formatedValidationMessage() {
	            return (0, _lodash.flatMapDeep)(this.messages.validation).map(function (msg) {
	                return '\u2022 ' + msg;
	            }).join('<br>');
	        }
	    }),
	    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['setMessage']), {
	        dismiss: function dismiss(type) {
	            var obj = void 0;
	            if (type === 'error') {
	                obj = { type: type, message: {} };
	            } else if (type === 'validation') {
	                obj = { type: type, message: {} };
	            } else {
	                obj = { type: type, message: '' };
	            }
	            this.setMessage(obj);
	        }
	    })
	};

/***/ }),

/***/ 583:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(24);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(6);
	
	var _navbar = __webpack_require__(1050);
	
	var _navbar2 = _interopRequireDefault(_navbar);
	
	var _sidebar = __webpack_require__(1051);
	
	var _sidebar2 = _interopRequireDefault(_sidebar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    components: {
	        NavBar: _navbar2.default, SideBar: _sidebar2.default
	    },
	    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['shouldShowNavigation']))
	
	};

/***/ }),

/***/ 584:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends2 = __webpack_require__(24);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _stringify = __webpack_require__(19);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _keys = __webpack_require__(28);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _vuex = __webpack_require__(6);
	
	var _config = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		data: function data() {
			return {
				company_logo: '',
				company_logo_exist: 2,
				status: '',
				selected_company: '',
				company_id: '',
				permissions: {
					general: 1
				},
				remaining_days: '',
				quickmenu: '',
				activemenu: 'text-complete',
				currentRouteName: '',
				user: {}
			};
		},
	
		props: ['type', 'routeHeader', 'routePath', 'modifyData', 'refreshCampaignComponent', 'suborg'],
		beforeMount: function beforeMount() {
			var _this = this;
	
			var currentURL = window.location.pathname;
			this.currentURL = currentURL;
			var permissions = JSON.parse(localStorage.getItem("permissions"));
			if (permissions) {
				this.permissions.general = permissions.general;
			}
	
			this.$http.get('/setting/company_logo').then(function (response) {
				_this.company_logo_exist = 1;
				_this.company_logo = response.data.data.logo;
				_this.company_id = response.data.data.company_id;
				_this.status = response.data.data.status;
				_this.selected_company = response.data.data.selected_company;
	
				var educateDomainUrl = response.data.data.active_educate_domain_url;
				var activeDomainUrl = (0, _keys2.default)(educateDomainUrl).find(function (key) {
					return educateDomainUrl[key] === true;
				});
				var fullDomain = 'https://' + activeDomainUrl + '/';
				localStorage.setItem('activeEducationDomain', fullDomain);
	
				localStorage.setItem('company_logo', (0, _stringify2.default)(response.data.data));
			});
			this.remaining_days = JSON.parse(localStorage.getItem('expired_in'));
			if (!this.currentUser) {
				this.$router.push({ name: 'auth.login' });
			}
			this.currentRouteName = this.$router.currentRoute.name;
	
			this.user = JSON.parse(localStorage.getItem('user'));
		},
	
		computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['currentUser'])),
		methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['logout']), {
			logoutUser: function logoutUser() {
	
				this.logout();
				localStorage.setItem('user', null);
	
				window.location = _config.appUrl + '/logout';
			},
			updateAdminLogin: function updateAdminLogin() {
				var data = {};
				data.admin_company_id = this.company_id;
				this.$http.post('/adminlogin/updateadminlogin', data).then(function (response) {
					if (response.data) {
						location.reload();
					}
				});
			},
			quickview: function quickview() {
				if (this.quickmenu == 'open') {
					this.quickmenu = '';
				} else {
					this.quickmenu = 'open';
				}
			}
		})
	};

/***/ }),

/***/ 585:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _http = __webpack_require__(5);
	
	exports.default = {
		data: function data() {
			return {
				campaignUserRole: '',
				user_permission: {
					data: {
						campaign_view: '',
						campaign_create: '',
						campaign_schedule: '',
						announcement_view: '',
						announcement_create: '',
						view_recepients: '',
						add_new_recepients: '',
						view_report: '',
						add_new_report: '',
						domain: '',
						general: '',
						user_management: '',
						retest_frequency: '',
						direct_learning_management: '',
						direct_learning_invitation_mail: '',
						direct_learning_login_mail: '',
						direct_learning_with_username_and_password_mail: '',
						landing_oops: '',
						training_mail: '',
						email_setting: '',
						company_logo: {
							logo: ''
						}
					}
				}
			};
		},
	
		computed: {
			canApproveWorkspace: function canApproveWorkspace() {
				return this.campaignUserRole === 'approver' || this.campaignUserRole === 'both';
			},
			canCreateWorkspace: function canCreateWorkspace() {
				return this.campaignUserRole === 'creator' || this.campaignUserRole === 'both';
			}
		},
		created: function created() {
			var _this = this;
	
			_http.http.get('setting/user-role-name').then(function (response) {
				var roleName = response.data && response.data.role_name ? response.data.role_name : '';
				_this.campaignUserRole = roleName;
				localStorage.setItem('campaignUserRole', roleName);
			}).catch(function () {
				_this.campaignUserRole = localStorage.getItem('campaignUserRole') || '';
			});
		}
	};

/***/ }),

/***/ 587:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(588);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 588:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var adn = function adn(r) {
	  return __webpack_require__.e/* nsure */(20, function () {
	    return r(__webpack_require__(918));
	  });
	};

/***/ }),

/***/ 589:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	
	var Auth = {
	    login: function login(r) {
	        return __webpack_require__.e/* nsure */(10, function () {
	            return r(__webpack_require__(921));
	        });
	    },
	    register: function register(r) {
	        return __webpack_require__.e/* nsure */(10, function () {
	            return r(__webpack_require__(923));
	        });
	    },
	    verification: function verification(r) {
	        return __webpack_require__.e/* nsure */(10, function () {
	            return r(__webpack_require__(926));
	        });
	    },
	    'learning': function learning(r) {
	        return __webpack_require__.e/* nsure */(10, function () {
	            return r(__webpack_require__(920));
	        });
	    },
	    'learningdashboard': function learningdashboard(r) {
	        return __webpack_require__.e/* nsure */(13, function () {
	            return r(__webpack_require__(949));
	        });
	    },
	    'learningreport': function learningreport(r) {
	        return __webpack_require__.e/* nsure */(12, function () {
	            return r(__webpack_require__(950));
	        });
	    },
	    'registered': function registered(r) {
	        return __webpack_require__.e/* nsure */(16, function () {
	            return r(__webpack_require__(924));
	        });
	    }
	};
	
	var ForgetPassword = function ForgetPassword(r) {
	    return __webpack_require__.e/* nsure */(17, function () {
	        return r(__webpack_require__(919));
	    });
	};
	var PrivacyPolicy = function PrivacyPolicy(r) {
	    return __webpack_require__.e/* nsure */(19, function () {
	        return r(__webpack_require__(922));
	    });
	};
	var termsAndConditions = function termsAndConditions(r) {
	    return __webpack_require__.e/* nsure */(18, function () {
	        return r(__webpack_require__(925));
	    });
	};
	
	exports.default = [{
	    name: 'auth.login',
	    path: '/lms/course',
	    component: Auth.login,
	    meta: { requiresAuth: false }
	}, {
	    name: 'auth.register',
	    path: '/register',
	    component: Auth.register,
	    meta: { requiresAuth: false }
	}, {
	    name: 'auth.registered',
	    path: '/registered',
	    component: Auth.registered,
	    meta: { requiresAuth: false }
	}, {
	    name: 'auth.learning',
	    path: '/learning/login/:id',
	    component: Auth.learning,
	    meta: { requiresAuth: false }
	}, {
	    name: 'auth.learningdashboard',
	    path: '/learning/dashboard/:id',
	    component: Auth.learningdashboard,
	    meta: { requiresAuth: false }
	}, {
	    name: 'auth.learningreport',
	    path: '/learning/reports/:id',
	    component: Auth.learningreport,
	    meta: { requiresAuth: false }
	}, {
	    name: 'auth.verification',
	    path: '/verification',
	    component: Auth.verification,
	    meta: { requiresAuth: false }
	}, {
	    name: 'auth.reset',
	    path: '/reset',
	    component: ForgetPassword,
	    meta: { requiresAuth: false }
	}, {
	    name: 'auth.privacypolicy',
	    path: '/privacypolicy',
	    component: PrivacyPolicy,
	    meta: { requiresAuth: false }
	}, {
	    name: 'auth.termsAndConditions',
	    path: '/TermsAndConditions',
	    component: termsAndConditions,
	    meta: { requiresAuth: false }
	}, {
	    name: 'auth.licenceexpire',
	    path: '/licenceexpire',
	    component: Auth.licenceexpire,
	    meta: { requiresAuth: false }
	}, {
	    name: 'auth.registered',
	    path: '/registered',
	    component: Auth.registered,
	    meta: { requiresAuth: false }
	}];

/***/ }),

/***/ 590:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.loadUser = exports.checkUserToken = exports.setToken = exports.setUser = exports.logout = exports.attemptVerification = exports.loginLmsUser = exports.loginUser = exports.attemptRegister = exports.attemptLearningLogin = exports.attemptLogin = undefined;
	
	var _promise = __webpack_require__(36);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _stringify = __webpack_require__(19);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _localforage = __webpack_require__(187);
	
	var _localforage2 = _interopRequireDefault(_localforage);
	
	var _config = __webpack_require__(4);
	
	var _lodash = __webpack_require__(11);
	
	var _mutationsTypes = __webpack_require__(143);
	
	var TYPES = _interopRequireWildcard(_mutationsTypes);
	
	var _services = __webpack_require__(142);
	
	var services = _interopRequireWildcard(_services);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var attemptLogin = exports.attemptLogin = function attemptLogin(_ref, payload) {
	  var dispatch = _ref.dispatch;
	  return services.postLogin(payload).then(function (response) {
	    return response;
	  });
	};
	
	var attemptLearningLogin = exports.attemptLearningLogin = function attemptLearningLogin(_ref2, payload) {
	  var dispatch = _ref2.dispatch;
	  return services.postLearningLogin(payload).then(function (response) {
	    return response;
	  });
	};
	
	var attemptRegister = exports.attemptRegister = function attemptRegister(_ref3, payload) {
	  var dispatch = _ref3.dispatch;
	  return services.postRegister(payload).then(function (response) {
	    return response;
	  });
	};
	
	var loginUser = exports.loginUser = function loginUser(_ref4, response) {
	  var dispatch = _ref4.dispatch;
	
	  dispatch('setToken', response.token);
	  dispatch('setUser', response);
	  localStorage.setItem('user', (0, _stringify2.default)(response));
	};
	
	var loginLmsUser = exports.loginLmsUser = function loginLmsUser(_ref5, response) {
	  var dispatch = _ref5.dispatch;
	
	  dispatch('setToken', response.token);
	  dispatch('setUser', response);
	  localStorage.setItem('user', (0, _stringify2.default)(response));
	};
	
	var attemptVerification = exports.attemptVerification = function attemptVerification(_ref6, payload) {
	  var dispatch = _ref6.dispatch;
	  return services.postVerification(payload).then(function (response) {
	    dispatch('setToken', null);
	    dispatch('setToken', response.data.token);
	    dispatch('setUser', response.data);
	    localStorage.setItem('user', (0, _stringify2.default)(response.data));
	
	    return response;
	  });
	};
	
	var logout = exports.logout = function logout(_ref7) {
	  var dispatch = _ref7.dispatch;
	
	  return _promise2.default.all([dispatch('setToken', null), dispatch('setUser', {})]);
	};
	
	var setUser = exports.setUser = function setUser(_ref8, user) {
	  var commit = _ref8.commit;
	
	  commit(TYPES.SET_USER, user);
	
	  _promise2.default.resolve(user);
	};
	
	var setToken = exports.setToken = function setToken(_ref9, payload) {
	  var commit = _ref9.commit;
	
	  var token = (0, _lodash.isEmpty)(payload) ? null : payload.token || payload;
	
	  commit(TYPES.SET_TOKEN, token);
	
	  return _promise2.default.resolve(token);
	};
	
	var checkUserToken = exports.checkUserToken = function checkUserToken(_ref10) {
	  var dispatch = _ref10.dispatch,
	      state = _ref10.state;
	
	  if (!(0, _lodash.isEmpty)(state.token)) {
	    return _promise2.default.resolve(state.token);
	  }
	
	  return _localforage2.default.getItem(_config.userTokenStorageKey).then(function (token) {
	    if ((0, _lodash.isEmpty)(token)) {
	      return _promise2.default.reject('NO_TOKEN');
	    }
	
	    return dispatch('setToken', token);
	  }).then(function () {
	    return dispatch('loadUser');
	  });
	};
	
	var loadUser = exports.loadUser = function loadUser(_ref11) {
	  var dispatch = _ref11.dispatch;
	
	  var user = JSON.parse(localStorage.getItem('user'));
	  ;
	  return _promise2.default.resolve(dispatch('setUser', user));
	};

/***/ }),

/***/ 591:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.currentUser = exports.isLogged = undefined;
	
	var _lodash = __webpack_require__(11);
	
	var isLogged = exports.isLogged = function isLogged(_ref) {
	  var token = _ref.token;
	  return !(0, _lodash.isEmpty)(token);
	};
	var currentUser = exports.currentUser = function currentUser(_ref2) {
	  var user = _ref2.user;
	  return user;
	};

/***/ }),

/***/ 592:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(595);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(593);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	var _plugin = __webpack_require__(594);
	
	var _plugin2 = _interopRequireDefault(_plugin);
	
	var _actions = __webpack_require__(590);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _getters = __webpack_require__(591);
	
	var getters = _interopRequireWildcard(_getters);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = { state: _state2.default, mutations: _mutations2.default, actions: actions, getters: getters };
	
	exports.default = { module: _module, plugin: _plugin2.default };

/***/ }),

/***/ 593:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _TYPES$SET_TOKEN$TYPE;
	
	var _mutationsTypes = __webpack_require__(143);
	
	var TYPES = _interopRequireWildcard(_mutationsTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (_TYPES$SET_TOKEN$TYPE = {}, (0, _defineProperty3.default)(_TYPES$SET_TOKEN$TYPE, TYPES.SET_TOKEN, function (state, value) {
	  state.token = value;
	}), (0, _defineProperty3.default)(_TYPES$SET_TOKEN$TYPE, TYPES.SET_USER, function (state, value) {
	  state.user = value;
	}), _TYPES$SET_TOKEN$TYPE);

/***/ }),

/***/ 594:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _localforage = __webpack_require__(187);
	
	var _localforage2 = _interopRequireDefault(_localforage);
	
	var _config = __webpack_require__(4);
	
	var _http = __webpack_require__(5);
	
	var _mutationsTypes = __webpack_require__(143);
	
	var TYPES = _interopRequireWildcard(_mutationsTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var subscribe = function subscribe(store) {
	  store.subscribe(function (mutation, _ref) {
	    var Auth = _ref.Auth;
	
	    if (TYPES.SET_TOKEN === mutation.type) {
	      (0, _http.setToken)(Auth.token);
	
	      _localforage2.default.setItem(_config.userTokenStorageKey, Auth.token);
	    }
	  });
	};
	
	exports.default = function (store) {
	  subscribe(store);
	};

/***/ }),

/***/ 595:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(146);
	
	var _state2 = _interopRequireDefault(_state);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  user: {},
	  token: null
	};

/***/ }),

/***/ 596:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	
	var campaigns = function campaigns(r) {
	    return __webpack_require__.e/* nsure */(7, function () {
	        return r(__webpack_require__(930));
	    });
	};
	
	var previewScenario = function previewScenario(r) {
	    return __webpack_require__.e/* nsure */(14, function () {
	        return r(__webpack_require__(931));
	    });
	};
	
	var bulk_campaign_preview = function bulk_campaign_preview(r) {
	    return __webpack_require__.e/* nsure */(7, function () {
	        return r(__webpack_require__(927));
	    });
	};
	
	var bulk_campaign_preview_edit = function bulk_campaign_preview_edit(r) {
	    return __webpack_require__.e/* nsure */(7, function () {
	        return r(__webpack_require__(928));
	    });
	};
	
	var manageCampaign = {
	
	    create: function create(r) {
	        return __webpack_require__.e/* nsure */(2, function () {
	            return r(__webpack_require__(929));
	        });
	    }
	
	};
	
	exports.default = [{
	    name: 'bulk_campaigns',
	    path: '/bulk/campaigns',
	
	    component: campaigns
	
	}, {
	    name: 'bulk_campaigns.schedule',
	    path: '/bulk/campains/schedule/:id',
	
	    component: manageCampaign.create
	}, {
	    name: 'previewScenario',
	    path: '/previewScenario/:id',
	    component: previewScenario
	}, {
	    name: 'bulkcampaign_preview',
	    path: '/bulk_campaign/preview/:id',
	    component: bulk_campaign_preview
	}, {
	    name: 'bulkcampaign_preview_edit',
	    path: '/bulk_campaign/preview/edit/:id',
	    component: bulk_campaign_preview_edit
	}];

/***/ }),

/***/ 597:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	
	var campaigns = function campaigns(r) {
	    return __webpack_require__.e/* nsure */(7, function () {
	        return r(__webpack_require__(933));
	    });
	};
	var preview = function preview(r) {
	    return __webpack_require__.e/* nsure */(7, function () {
	        return r(__webpack_require__(943));
	    });
	};
	var bulkpreview = function bulkpreview(r) {
	    return __webpack_require__.e/* nsure */(7, function () {
	        return r(__webpack_require__(932));
	    });
	};
	var manageCampaign = {
	    index: function index(r) {
	        return __webpack_require__.e/* nsure */(2, function () {
	            return r(__webpack_require__(942));
	        });
	    },
	    create: function create(r) {
	        return __webpack_require__.e/* nsure */(2, function () {
	            return r(__webpack_require__(934));
	        });
	    },
	    description: function description(r) {
	        return __webpack_require__.e/* nsure */(2, function () {
	            return r(__webpack_require__(935));
	        });
	    },
	    email: function email(r) {
	        return __webpack_require__.e/* nsure */(2, function () {
	            return r(__webpack_require__(937));
	        });
	    },
	    sms: function sms(r) {
	        return __webpack_require__.e/* nsure */(2, function () {
	            return r(__webpack_require__(941));
	        });
	    },
	    landing: function landing(r) {
	        return __webpack_require__.e/* nsure */(2, function () {
	            return r(__webpack_require__(938));
	        });
	    },
	    education: function education(r) {
	        return __webpack_require__.e/* nsure */(2, function () {
	            return r(__webpack_require__(936));
	        });
	    },
	    schedule: function schedule(r) {
	        return __webpack_require__.e/* nsure */(2, function () {
	            return r(__webpack_require__(940));
	        });
	    },
	    review: function review(r) {
	        return __webpack_require__.e/* nsure */(2, function () {
	            return r(__webpack_require__(939));
	        });
	    }
	};
	
	exports.default = [{
	    name: 'campaigns',
	    path: '/campaigns',
	    alias: '/announcements',
	    component: campaigns
	}, {
	    name: 'preview',
	    path: '/campaigns/preview/:id',
	    alias: '/announcements/preview/:id',
	    component: preview
	}, {
	    name: 'bulk/preview',
	    path: '/campaigns/bulk/preview/:id',
	    component: bulkpreview
	}, {
	    name: 'campaigns.index',
	    path: '/campains/create',
	    alias: '/announcements/create',
	    component: manageCampaign.index,
	    redirect: { name: 'campaigns.create' },
	    children: [{
	        name: 'campaigns.create',
	        path: '/campaigns/create',
	        alias: '/announcements/create',
	        component: manageCampaign.create
	    }, {
	        name: 'campaigns.edit.description',
	        path: '/campaigns/description/:id',
	        alias: '/announcements/description/:id',
	        component: manageCampaign.description
	    }, {
	        name: 'campaigns.edit.email',
	        path: '/campaigns/email/:id',
	        alias: '/announcements/email/:id',
	        component: manageCampaign.email
	    }, {
	        name: 'campaigns.edit.sms',
	        path: '/campaigns/sms/:id',
	        alias: '/announcements/sms/:id',
	        component: manageCampaign.sms
	    }, {
	        name: 'campaigns.edit.landing',
	        path: '/campaigns/landing/:id',
	        alias: '/announcements/landing/:id',
	        component: manageCampaign.landing
	    }, {
	        name: 'campaigns.edit.education',
	        path: '/campaigns/education/:id',
	        alias: '/announcements/education/:id',
	        component: manageCampaign.education
	    }, {
	        name: 'campaigns.edit.schedule',
	        path: '/campaigns/schedule/:id',
	        alias: '/announcements/schedule/:id',
	        component: manageCampaign.schedule
	    }, {
	        name: 'campaigns.edit.review',
	        path: '/campaigns/review/:id',
	        alias: '/announcements/review/:id',
	        component: manageCampaign.review
	    }]
	}];

/***/ }),

/***/ 598:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	
	var domains = function domains(r) {
	    return __webpack_require__.e/* nsure */(15, function () {
	        r(__webpack_require__(944));
	    });
	};
	
	exports.default = [{
	    name: 'company.domains',
	    path: '/company/domains',
	    component: domains
	}];

/***/ }),

/***/ 599:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setDomains = exports.LOAD_DOMAIN_LIST = exports.addCompanyDomain = undefined;
	
	var _promise = __webpack_require__(36);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _services = __webpack_require__(210);
	
	var services = _interopRequireWildcard(_services);
	
	var _mutationsTypes = __webpack_require__(211);
	
	var TYPES = _interopRequireWildcard(_mutationsTypes);
	
	var _state = __webpack_require__(212);
	
	var _state2 = _interopRequireDefault(_state);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var addCompanyDomain = exports.addCompanyDomain = function addCompanyDomain(_ref, payload) {
	  var dispatch = _ref.dispatch;
	  return services.addNewDomain(payload).then(function (_ref2) {
	    var message = _ref2.message,
	        status_code = _ref2.status_code;
	
	    console.log(message, status_code);
	  });
	};
	
	var LOAD_DOMAIN_LIST = exports.LOAD_DOMAIN_LIST = function LOAD_DOMAIN_LIST(_ref3) {
	  var dispatch = _ref3.dispatch;
	
	
	  services.getDomains().then(function (response) {
	    console.log('state', _state2.default);
	
	    dispatch('setDomains', response.data);
	    return _promise2.default.resolve(response);
	  }).catch(function (error) {
	
	    console.log('error', error);
	    return _promise2.default.reject('FAIL_IN_LOAD_COMPANY_DOMAINS');
	  });
	};
	
	var setDomains = exports.setDomains = function setDomains(_ref4, list) {
	  var commit = _ref4.commit;
	
	  console.log('commiter', commit);
	  console.log('list', list);
	
	  commit(TYPES.SET_DOMAIN_LIST, list);
	
	  console.log(_state2.default);
	
	  return _promise2.default.resolve(list);
	};

/***/ }),

/***/ 600:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var getDomains = exports.getDomains = function getDomains(_ref) {
	  var state = _ref.state;
	  return state.domains;
	};

/***/ }),

/***/ 601:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(212);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(602);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	var _actions = __webpack_require__(599);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _getters = __webpack_require__(600);
	
	var getters = _interopRequireWildcard(_getters);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = { state: _state2.default, actions: actions, mutations: _mutations2.default, getters: getters };
	
	exports.default = { module: _module };

/***/ }),

/***/ 602:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mutationsTypes = __webpack_require__(211);
	
	var TYPES = _interopRequireWildcard(_mutationsTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _defineProperty3.default)({}, TYPES.SET_DOMAIN_LIST, function (state, list) {
	    state.domains = list;
	});

/***/ }),

/***/ 603:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var Dashboard = function Dashboard(r) {
	  return __webpack_require__.e/* nsure */(9, function () {
	    return r(__webpack_require__(946));
	  });
	};
	var CompanyList = function CompanyList(r) {
	  return __webpack_require__.e/* nsure */(9, function () {
	    return r(__webpack_require__(945));
	  });
	};
	var ReportedPluginUsers = function ReportedPluginUsers(r) {
	  return __webpack_require__.e/* nsure */(9, function () {
	    return r(__webpack_require__(947));
	  });
	};
	var WeakestLinkUser = function WeakestLinkUser(r) {
	  return __webpack_require__.e/* nsure */(9, function () {
	    return r(__webpack_require__(948));
	  });
	};
	
	exports.default = [{
	  name: 'pluginusers',
	  path: '/reported/pluginusers',
	  component: ReportedPluginUsers
	}, {
	  name: 'dashboard.companylist',
	  path: '/companylist',
	  component: CompanyList
	}, {
	  name: 'dashboard.weakestlinkuser',
	  path: '/weakestlink',
	  component: WeakestLinkUser
	}];

/***/ }),

/***/ 604:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(605);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 605:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
			value: true
	});
	
	
	var laggards = {
			index: function index(r) {
					return __webpack_require__.e/* nsure */(3, function () {
							return r(__webpack_require__(952));
					});
			},
			edit: function edit(r) {
					return __webpack_require__.e/* nsure */(3, function () {
							return r(__webpack_require__(951));
					});
			}
	};
	
	exports.default = [{
			name: 'laggards',
			path: '/laggards',
			component: laggards.index
	}, {
			name: 'laggards.edit',
			path: '/laggards/:id',
			component: laggards.edit
	}];

/***/ }),

/***/ 606:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(607);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 607:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
			value: true
	});
	
	
	var leaderboard = {
			index: function index(r) {
					return __webpack_require__.e/* nsure */(3, function () {
							return r(__webpack_require__(954));
					});
			},
			edit: function edit(r) {
					return __webpack_require__.e/* nsure */(3, function () {
							return r(__webpack_require__(953));
					});
			}
	};
	
	exports.default = [{
			name: 'leaderboard',
			path: '/leaderboard',
			component: leaderboard.index
	}, {
			name: 'leaderboard.edit',
			path: '/leaderboard/:id',
			component: leaderboard.edit
	}];

/***/ }),

/***/ 611:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(613);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 612:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	                                value: true
	});
	var courses = exports.courses = function courses(r) {
	                                return __webpack_require__.e/* nsure */(0, function () {
	                                                                return r(__webpack_require__(965));
	                                });
	};
	var Reports = exports.Reports = function Reports(r) {
	                                return __webpack_require__.e/* nsure */(0, function () {
	                                                                return r(__webpack_require__(979));
	                                });
	};
	var Learners = exports.Learners = function Learners(r) {
	                                return __webpack_require__.e/* nsure */(0, function () {
	                                                                return r(__webpack_require__(980));
	                                });
	};
	var Departments = exports.Departments = function Departments(r) {
	                                return __webpack_require__.e/* nsure */(0, function () {
	                                                                return r(__webpack_require__(977));
	                                });
	};
	var Courses = exports.Courses = function Courses(r) {
	                                return __webpack_require__.e/* nsure */(0, function () {
	                                                                return r(__webpack_require__(975));
	                                });
	};
	
	var DepartmentTargets = exports.DepartmentTargets = function DepartmentTargets(r) {
	                                return __webpack_require__.e/* nsure */(0, function () {
	                                                                return r(__webpack_require__(976));
	                                });
	};
	var TargetCourses = exports.TargetCourses = function TargetCourses(r) {
	                                return __webpack_require__.e/* nsure */(0, function () {
	                                                                return r(__webpack_require__(981));
	                                });
	};
	
	var Emaillogs = exports.Emaillogs = function Emaillogs(r) {
	                                return __webpack_require__.e/* nsure */(0, function () {
	                                                                return r(__webpack_require__(973));
	                                });
	};
	var Teamslogs = exports.Teamslogs = function Teamslogs(r) {
	                                return __webpack_require__.e/* nsure */(0, function () {
	                                                                return r(__webpack_require__(974));
	                                });
	};
	var Exported = exports.Exported = function Exported(r) {
	                                return __webpack_require__.e/* nsure */(0, function () {
	                                                                return r(__webpack_require__(978));
	                                });
	};
	var Approvals = exports.Approvals = function Approvals(r) {
	                                return __webpack_require__.e/* nsure */(0, function () {
	                                                                return r(__webpack_require__(956));
	                                });
	};
	var ApprovalDetail = exports.ApprovalDetail = function ApprovalDetail(r) {
	                                return __webpack_require__.e/* nsure */(0, function () {
	                                                                return r(__webpack_require__(955));
	                                });
	};

/***/ }),

/***/ 613:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _components = __webpack_require__(612);
	
	var component = _interopRequireWildcard(_components);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var manageCourse = {
	    index: function index(r) {
	        return __webpack_require__.e/* nsure */(4, function () {
	            return r(__webpack_require__(968));
	        });
	    },
	    general: function general(r) {
	        return __webpack_require__.e/* nsure */(4, function () {
	            return r(__webpack_require__(967));
	        });
	    },
	    notification: function notification(r) {
	        return __webpack_require__.e/* nsure */(4, function () {
	            return r(__webpack_require__(970));
	        });
	    },
	    completion: function completion(r) {
	        return __webpack_require__.e/* nsure */(4, function () {
	            return r(__webpack_require__(964));
	        });
	    },
	    enrolments: function enrolments(r) {
	        return __webpack_require__.e/* nsure */(4, function () {
	            return r(__webpack_require__(966));
	        });
	    },
	    settings: function settings(r) {
	        return __webpack_require__.e/* nsure */(4, function () {
	            return r(__webpack_require__(972));
	        });
	    }
	};
	var learningPath = function learningPath(r) {
	    return __webpack_require__.e/* nsure */(4, function () {
	        return r(__webpack_require__(969));
	    });
	};
	var manageSetting = {
	    index: function index(r) {
	        return __webpack_require__.e/* nsure */(6, function () {
	            return r(__webpack_require__(985));
	        });
	    },
	    general: function general(r) {
	        return __webpack_require__.e/* nsure */(6, function () {
	            return r(__webpack_require__(984));
	        });
	    },
	    gamification: function gamification(r) {
	        return __webpack_require__.e/* nsure */(6, function () {
	            return r(__webpack_require__(983));
	        });
	    },
	    certificate: function certificate(r) {
	        return __webpack_require__.e/* nsure */(6, function () {
	            return r(__webpack_require__(982));
	        });
	    },
	    notificationstemplates: function notificationstemplates(r) {
	        return __webpack_require__.e/* nsure */(6, function () {
	            return r(__webpack_require__(987));
	        });
	    },
	    integrations: function integrations(r) {
	        return __webpack_require__.e/* nsure */(6, function () {
	            return r(__webpack_require__(986));
	        });
	    }
	};
	var editCourse = {
	    editindex: function editindex(r) {
	        return __webpack_require__.e/* nsure */(8, function () {
	            return r(__webpack_require__(961));
	        });
	    },
	    general: function general(r) {
	        return __webpack_require__.e/* nsure */(8, function () {
	            return r(__webpack_require__(960));
	        });
	    },
	    notification: function notification(r) {
	        return __webpack_require__.e/* nsure */(8, function () {
	            return r(__webpack_require__(962));
	        });
	    },
	    completion: function completion(r) {
	        return __webpack_require__.e/* nsure */(8, function () {
	            return r(__webpack_require__(958));
	        });
	    },
	    enrolments: function enrolments(r) {
	        return __webpack_require__.e/* nsure */(8, function () {
	            return r(__webpack_require__(959));
	        });
	    }
	};
	exports.default = [{
	    name: 'lms.courses',
	    path: '/',
	    component: component.courses
	}, {
	    name: 'lms.courses',
	    path: '/lms/courses',
	    component: component.courses
	}, {
	    name: 'lms.learningpath',
	    path: '/lms/learning-path',
	    component: learningPath
	}, {
	    name: 'lms.approvals',
	    path: '/lms/approvals',
	    component: component.Approvals
	}, {
	    name: 'lms.creatorapprovals',
	    path: '/lms/creator-approvals',
	    component: component.Approvals
	}, {
	    name: 'lms.approvaldetail',
	    path: '/lms/approvals/detail/:batchId',
	    component: component.ApprovalDetail
	}, {
	    name: 'lms.index',
	    path: '/lms/general/:id',
	    component: manageCourse.index,
	    redirect: { name: 'lms.general/:id' },
	    children: [{
	        name: 'lms.general',
	        path: '/lms/general/:id',
	        component: manageCourse.general
	    }, {
	        name: 'lms.notification',
	        path: '/lms/notification/:id',
	        component: manageCourse.notification
	    }, {
	        name: 'lms.completion',
	        path: '/lms/completion/:id',
	        component: manageCourse.completion
	    }, {
	        name: 'lms.enrolments',
	        path: '/lms/enrolments/:id',
	        component: manageCourse.enrolments
	    }, {
	        name: 'lms.settings',
	        path: '/lms/settings/:id',
	        component: manageCourse.settings
	    }]
	}, {
	    name: 'lms.editindex',
	    path: '/lms/editgeneral/:id',
	    component: editCourse.editindex,
	    redirect: { name: 'lms.editgeneral' },
	    children: [{
	        name: 'lms.editgeneral',
	        path: '/lms/editgeneral/:id',
	        component: editCourse.editgeneral
	    }, {
	        name: 'lms.editnotification',
	        path: '/lms/editnotification/:id',
	        component: editCourse.editnotification
	    }, {
	        name: 'lms.editcompletion',
	        path: '/lms/editcompletion/:id',
	        component: editCourse.editcompletion
	    }, {
	        name: 'lms.editenrolments',
	        path: '/lms/editenrolments/:id',
	        component: editCourse.editenrolments
	    }]
	}, {
	    name: 'lms.index',
	    path: '/lms/setting',
	    component: manageSetting.index,
	    redirect: { name: 'lms.setting' },
	    children: [{
	        name: 'lms.setting',
	        path: '/lms/setting',
	        component: manageSetting.general
	    }, {
	        name: 'lms.gamification',
	        path: '/lms/gamification',
	        component: manageSetting.gamification
	    }, {
	        name: 'lms.certificate',
	        path: '/lms/certificate',
	        component: manageSetting.certificate
	    }, {
	        name: 'lms.notificationstemplates',
	        path: '/lms/notificationstemplates',
	        component: manageSetting.notificationstemplates
	    }, {
	        name: 'lms.integrations',
	        path: '/lms/integrations',
	        component: manageSetting.integrations
	    }]
	}, {
	    name: 'lms.reports',
	    path: '/lms/reports',
	    component: component.Reports
	}, {
	    name: 'lms.reportcourses',
	    path: '/lms/reports/courses',
	    component: component.Courses
	}, {
	    name: 'lms.learner_results',
	    path: '/lms/reports/learner_results',
	    component: component.Courses
	}, {
	    name: 'lms.reportdepartments',
	    path: '/lms/reports/departments',
	    component: component.Departments
	}, {
	    name: 'lms.exported',
	    path: '/lms/reports/exported_files',
	    component: component.Exported
	}, {
	    name: 'lms.reportlearners',
	    path: '/lms/reports/learners',
	    component: component.Learners
	}, {
	    name: 'lms.reportdepartment_targets',
	    path: '/lms/reports/department_targets',
	    component: component.DepartmentTargets
	}, {
	    name: 'lms.reporttarget_courses',
	    path: '/lms/reports/target_courses',
	    component: component.TargetCourses
	}, {
	    name: 'lms.emaillogs',
	    path: '/lms/sent-emails',
	    component: component.Emaillogs
	}, {
	    name: 'lms.teamslogs',
	    path: '/lms/teams-notification-logs',
	    component: component.Teamslogs
	}];

/***/ }),

/***/ 614:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(616);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 615:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var PhishingVulnerabilityTrend = exports.PhishingVulnerabilityTrend = function PhishingVulnerabilityTrend(r) {
	  return __webpack_require__.e/* nsure */(0, function () {
	    return r(__webpack_require__(991));
	  });
	};
	
	var AwarenessTrendsLook = exports.AwarenessTrendsLook = function AwarenessTrendsLook(r) {
	  return __webpack_require__.e/* nsure */(0, function () {
	    return r(__webpack_require__(988));
	  });
	};
	
	var ReportingTrend = exports.ReportingTrend = function ReportingTrend(r) {
	  return __webpack_require__.e/* nsure */(0, function () {
	    return r(__webpack_require__(992));
	  });
	};
	
	var Weekest = exports.Weekest = function Weekest(r) {
	  return __webpack_require__.e/* nsure */(0, function () {
	    return r(__webpack_require__(994));
	  });
	};
	
	var Strongest = exports.Strongest = function Strongest(r) {
	  return __webpack_require__.e/* nsure */(0, function () {
	    return r(__webpack_require__(993));
	  });
	};
	
	var Deparmentweakest = exports.Deparmentweakest = function Deparmentweakest(r) {
	  return __webpack_require__.e/* nsure */(0, function () {
	    return r(__webpack_require__(989));
	  });
	};
	
	var Highrisk = exports.Highrisk = function Highrisk(r) {
	  return __webpack_require__.e/* nsure */(0, function () {
	    return r(__webpack_require__(990));
	  });
	};

/***/ }),

/***/ 616:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _components = __webpack_require__(615);
	
	var component = _interopRequireWildcard(_components);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = [{
	  name: 'managementreport.phishingvulnerability',
	  path: '/managementreport/phishingvulnerability',
	  component: component.PhishingVulnerabilityTrend
	}, {
	  name: 'managementreport.awarenesstrendslook',
	  path: '/managementreport/awarenesstrendslook',
	  component: component.AwarenessTrendsLook
	}, {
	  name: 'managementreport.reportingtrend',
	  path: '/managementreport/reportingtrend',
	  component: component.ReportingTrend
	}, {
	  name: 'managementreport.weakest',
	  path: '/managementreport/weakest',
	  component: component.Weekest
	}, {
	  name: 'managementreport.strongest',
	  path: '/managementreport/strongest',
	  component: component.Strongest
	}, {
	  name: 'managementreport.departmentweakest',
	  path: '/managementreport/departmentweakest',
	  component: component.Deparmentweakest
	}, {
	  name: 'managementreport.highrisk',
	  path: '/managementreport/highrisk',
	  component: component.Highrisk
	}];

/***/ }),

/***/ 617:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
			value: true
	});
	
	
	var recipients = {
			index: function index(r) {
					return __webpack_require__.e/* nsure */(3, function () {
							return r(__webpack_require__(997));
					});
			},
			imports: function imports(r) {
					return __webpack_require__.e/* nsure */(3, function () {
							return r(__webpack_require__(996));
					});
			},
			edit: function edit(r) {
					return __webpack_require__.e/* nsure */(3, function () {
							return r(__webpack_require__(995));
					});
			},
			suppressionlist: function suppressionlist(r) {
					return __webpack_require__.e/* nsure */(3, function () {
							return r(__webpack_require__(999));
					});
			},
			suppression: {
					imports: function imports(r) {
							return __webpack_require__.e/* nsure */(3, function () {
									return r(__webpack_require__(998));
							});
					}
			}
	};
	
	exports.default = [{
			name: 'recipients',
			path: '/recipients',
			component: recipients.index
	}, {
			name: 'suppression',
			path: '/suppression',
			component: recipients.suppressionlist
	}, {
			name: 'recipients.imports',
			path: '/import/recipients',
			component: recipients.imports
	}, {
			name: 'recipients.suppression.imports',
			path: '/imports/suppression',
			component: recipients.suppression.imports
	}, {
			name: 'recipients.edit',
			path: '/recipients/:id',
			component: recipients.edit
	}];

/***/ }),

/***/ 618:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	                                value: true
	});
	var ReportingNew = exports.ReportingNew = function ReportingNew(r) {
	                                return __webpack_require__.e/* nsure */(0, function () {
	                                                                return r(__webpack_require__(1010));
	                                });
	};
	
	var Reporting = exports.Reporting = function Reporting(r) {
	                                return __webpack_require__.e/* nsure */(0, function () {
	                                                                return r(__webpack_require__(1008));
	                                });
	};
	
	var ReportingsNew = exports.ReportingsNew = function ReportingsNew(r) {
	                                return __webpack_require__.e/* nsure */(0, function () {
	                                                                return r(__webpack_require__(1009));
	                                });
	};
	
	var RepeatAffender = exports.RepeatAffender = function RepeatAffender(r) {
	                                return __webpack_require__.e/* nsure */(0, function () {
	                                                                return r(__webpack_require__(1007));
	                                });
	};
	
	var campaignReporting = exports.campaignReporting = function campaignReporting(r) {
	                                return __webpack_require__.e/* nsure */(0, function () {
	                                                                return r(__webpack_require__(1001));
	                                });
	};
	
	var campaignReportingNew = exports.campaignReportingNew = function campaignReportingNew(r) {
	                                return __webpack_require__.e/* nsure */(0, function () {
	                                                                return r(__webpack_require__(1002));
	                                });
	};
	
	var compareReportingNew = exports.compareReportingNew = function compareReportingNew(r) {
	                                return __webpack_require__.e/* nsure */(0, function () {
	                                                                return r(__webpack_require__(1004));
	                                });
	};
	
	var recipientListing = exports.recipientListing = function recipientListing(r) {
	                                return __webpack_require__.e/* nsure */(0, function () {
	                                                                return r(__webpack_require__(1006));
	                                });
	};
	
	var campaignDetailedReporting = exports.campaignDetailedReporting = function campaignDetailedReporting(r) {
	                                return __webpack_require__.e/* nsure */(0, function () {
	                                                                return r(__webpack_require__(1000));
	                                });
	};
	
	var hcsa = exports.hcsa = function hcsa(r) {
	                                return __webpack_require__.e/* nsure */(0, function () {
	                                                                return r(__webpack_require__(1005));
	                                });
	};
	var campaignReportingScenario = exports.campaignReportingScenario = function campaignReportingScenario(r) {
	                                return __webpack_require__.e/* nsure */(0, function () {
	                                                                return r(__webpack_require__(1003));
	                                });
	};

/***/ }),

/***/ 619:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _components = __webpack_require__(618);
	
	var component = _interopRequireWildcard(_components);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = [{
	  name: 'report.campaignsnew',
	  path: '/report/campaignsnew',
	  component: component.ReportingNew,
	  meta: { requiresAuth: true }
	}, {
	  name: 'report.campaigns',
	  path: '/report/campaigns',
	  component: component.ReportingsNew
	}, {
	  name: 'report.allcampaigns',
	  path: '/report/allcampaigns',
	  component: component.ReportingsNew
	}, {
	  name: 'report.allannouncements',
	  path: '/report/allannouncements',
	  component: component.ReportingsNew
	}, {
	  name: 'report.campaigns.new',
	  path: '/report/campaigns/new',
	  component: component.ReportingsNew
	}, {
	  name: 'report.repeatAffender',
	  path: '/report/repeatAffender',
	  component: component.RepeatAffender
	}, {
	  name: 'report.campaignreporting',
	  path: '/report/campaigns/:id',
	
	  component: component.campaignReportingNew
	}, {
	  name: 'report.comparereporting',
	  path: '/report/compare/:id',
	
	  component: component.compareReportingNew
	}, {
	  name: 'report.campaignreporting.new',
	  path: '/report/campaigns/new/:id',
	  component: component.campaignReportingNew
	}, {
	  name: 'report.recipientlisting',
	
	  path: '/report/campaigns/:id/:type',
	  component: component.recipientListing
	}, {
	  name: 'report.detailedreporting',
	  path: '/report/detailed',
	  component: component.campaignDetailedReporting
	}, {
	  name: 'report.hcsa',
	  path: '/report/hcsa_hisp',
	  component: component.hcsa
	}, {
	  name: 'report.campaignreportingScenario',
	  path: '/scenarioreport/campaigns',
	  component: component.campaignReportingScenario
	}];

/***/ }),

/***/ 620:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(41);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _dashboard = __webpack_require__(213);
	
	var _company = __webpack_require__(209);
	
	var _bulk_campaign = __webpack_require__(207);
	
	var _recipient = __webpack_require__(217);
	
	var _campaign = __webpack_require__(208);
	
	var _report = __webpack_require__(218);
	
	var _setting = __webpack_require__(219);
	
	var _scenario = __webpack_require__(621);
	
	var _leaderboard = __webpack_require__(606);
	
	var _laggards = __webpack_require__(604);
	
	var _managementreport = __webpack_require__(614);
	
	var _lms = __webpack_require__(611);
	
	var _adn = __webpack_require__(587);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = [].concat((0, _toConsumableArray3.default)(_company.routes), (0, _toConsumableArray3.default)(_recipient.routes), (0, _toConsumableArray3.default)(_campaign.routes), (0, _toConsumableArray3.default)(_bulk_campaign.routes), (0, _toConsumableArray3.default)(_report.routes), (0, _toConsumableArray3.default)(_setting.routes), (0, _toConsumableArray3.default)(_scenario.routes), (0, _toConsumableArray3.default)(_laggards.routes), (0, _toConsumableArray3.default)(_dashboard.routes), (0, _toConsumableArray3.default)(_leaderboard.routes), (0, _toConsumableArray3.default)(_adn.routes), (0, _toConsumableArray3.default)(_managementreport.routes), (0, _toConsumableArray3.default)(_lms.routes));

/***/ }),

/***/ 621:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(622);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 622:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	
	var scenario = function scenario(r) {
	    return __webpack_require__.e/* nsure */(11, function () {
	        return r(__webpack_require__(1012));
	    });
	};
	
	var manageScenario = {
	    index: function index(r) {
	        return __webpack_require__.e/* nsure */(5, function () {
	            return r(__webpack_require__(1019));
	        });
	    },
	
	    description: function description(r) {
	        return __webpack_require__.e/* nsure */(5, function () {
	            return r(__webpack_require__(1013));
	        });
	    },
	    email: function email(r) {
	        return __webpack_require__.e/* nsure */(5, function () {
	            return r(__webpack_require__(1015));
	        });
	    },
	    sms: function sms(r) {
	        return __webpack_require__.e/* nsure */(5, function () {
	            return r(__webpack_require__(1018));
	        });
	    },
	    landing: function landing(r) {
	        return __webpack_require__.e/* nsure */(5, function () {
	            return r(__webpack_require__(1016));
	        });
	    },
	    education: function education(r) {
	        return __webpack_require__.e/* nsure */(5, function () {
	            return r(__webpack_require__(1014));
	        });
	    },
	    review: function review(r) {
	        return __webpack_require__.e/* nsure */(5, function () {
	            return r(__webpack_require__(1017));
	        });
	    }
	};
	
	exports.default = [{
	    name: 'scenario',
	    path: '/scenario',
	    component: scenario
	}, {
	    name: 'scenario.index',
	    path: '/scenario/create',
	    component: manageScenario.index,
	    redirect: { name: 'scenario.create' },
	    children: [{
	        name: 'scenario.description',
	        path: '/scenario/description',
	        component: manageScenario.description
	    }, {
	        name: 'scenario.edit.description',
	        path: '/scenario/description/:id',
	        component: manageScenario.description
	    }, {
	        name: 'scenario.edit.email',
	        path: '/scenario/email/:id',
	        component: manageScenario.email
	    }, {
	        name: 'scenario.edit.sms',
	        path: '/scenario/sms/:id',
	        component: manageScenario.sms
	    }, {
	        name: 'scenario.edit.landing',
	        path: '/scenario/landing/:id',
	        component: manageScenario.landing
	    }, {
	        name: 'scenario.edit.education',
	        path: '/scenario/education/:id',
	        component: manageScenario.education
	    }, {
	        name: 'scenario.edit.review',
	        path: '/scenario/review/:id',
	        component: manageScenario.review
	    }]
	}];

/***/ }),

/***/ 623:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var general = function general(r) {
	    return __webpack_require__.e/* nsure */(1, function () {
	        return r(__webpack_require__(1034));
	    });
	};
	var usermanagement = function usermanagement(r) {
	    return __webpack_require__.e/* nsure */(1, function () {
	        return r(__webpack_require__(1044));
	    });
	};
	var directlearning = function directlearning(r) {
	    return __webpack_require__.e/* nsure */(1, function () {
	        return r(__webpack_require__(1028));
	    });
	};
	var directlearning_recipient = function directlearning_recipient(r) {
	    return __webpack_require__.e/* nsure */(1, function () {
	        return r(__webpack_require__(1029));
	    });
	};
	var campaign = function campaign(r) {
	    return __webpack_require__.e/* nsure */(1, function () {
	        return r(__webpack_require__(1026));
	    });
	};
	var email = function email(r) {
	    return __webpack_require__.e/* nsure */(1, function () {
	        return r(__webpack_require__(1033));
	    });
	};
	var landing = function landing(r) {
	    return __webpack_require__.e/* nsure */(1, function () {
	        return r(__webpack_require__(1035));
	    });
	};
	var adform = function adform(r) {
	    return __webpack_require__.e/* nsure */(1, function () {
	        return r(__webpack_require__(1022));
	    });
	};
	var listad = function listad(r) {
	    return __webpack_require__.e/* nsure */(1, function () {
	        return r(__webpack_require__(1038));
	    });
	};
	var adlogs = function adlogs(r) {
	    return __webpack_require__.e/* nsure */(1, function () {
	        return r(__webpack_require__(1023));
	    });
	};
	var alladlogs = function alladlogs(r) {
	    return __webpack_require__.e/* nsure */(1, function () {
	        return r(__webpack_require__(1024));
	    });
	};
	var oopspage = function oopspage(r) {
	    return __webpack_require__.e/* nsure */(1, function () {
	        return r(__webpack_require__(1036));
	    });
	};
	
	var trainingmail = function trainingmail(r) {
	    return __webpack_require__.e/* nsure */(1, function () {
	        return r(__webpack_require__(399));
	    });
	};
	var dl_invitation_mail = function dl_invitation_mail(r) {
	    return __webpack_require__.e/* nsure */(1, function () {
	        return r(__webpack_require__(1030));
	    });
	};
	var dl_login_link_mail = function dl_login_link_mail(r) {
	    return __webpack_require__.e/* nsure */(1, function () {
	        return r(__webpack_require__(1031));
	    });
	};
	var dl_login_with_password_mail = function dl_login_with_password_mail(r) {
	    return __webpack_require__.e/* nsure */(1, function () {
	        return r(__webpack_require__(1032));
	    });
	};
	var security = function security(r) {
	    return __webpack_require__.e/* nsure */(1, function () {
	        return r(__webpack_require__(1042));
	    });
	};
	var azure = function azure(r) {
	    return __webpack_require__.e/* nsure */(1, function () {
	        return r(__webpack_require__(1025));
	    });
	};
	var books = function books(r) {
	    return __webpack_require__.e/* nsure */(1, function () {
	        return r(__webpack_require__(1020));
	    });
	};
	
	var changepassword = function changepassword(r) {
	    return __webpack_require__.e/* nsure */(1, function () {
	        return r(__webpack_require__(1027));
	    });
	};
	var bulkeducation = function bulkeducation(r) {
	    return __webpack_require__.e/* nsure */(1, function () {
	        return r(__webpack_require__(1021));
	    });
	};
	var point_configure = function point_configure(r) {
	    return __webpack_require__.e/* nsure */(1, function () {
	        return r(__webpack_require__(1040));
	    });
	};
	var reminder = function reminder(r) {
	    return __webpack_require__.e/* nsure */(1, function () {
	        return r(__webpack_require__(1041));
	    });
	};
	var leaderboardsetting = function leaderboardsetting(r) {
	    return __webpack_require__.e/* nsure */(1, function () {
	        return r(__webpack_require__(1037));
	    });
	};
	var welcome_mail = function welcome_mail(r) {
	    return __webpack_require__.e/* nsure */(1, function () {
	        return r(__webpack_require__(1045));
	    });
	};
	var trainingmodule = function trainingmodule(r) {
	    return __webpack_require__.e/* nsure */(1, function () {
	        return r(__webpack_require__(1043));
	    });
	};
	var master_landing = function master_landing(r) {
	    return __webpack_require__.e/* nsure */(1, function () {
	        return r(__webpack_require__(1039));
	    });
	};
	var reminder_template = function reminder_template(r) {
	    return __webpack_require__.e/* nsure */(1, function () {
	        return r(__webpack_require__(399));
	    });
	};
	var throttling_sending_speed = function throttling_sending_speed(r) {
	    return __webpack_require__.e/* nsure */(1, function () {
	        return r(__webpack_require__(1046));
	    });
	};
	exports.default = [{
	    name: 'general',
	    path: '/setting/general',
	    component: general
	}, {
	    name: 'throttling_sending_speed',
	    path: '/setting/throttling_sending_speed',
	    component: throttling_sending_speed
	}, {
	    name: 'master_landing',
	    path: '/setting/master_landing',
	    component: master_landing
	}, {
	    name: 'trainingmodule',
	    path: '/setting/trainingmodule',
	    component: trainingmodule
	}, {
	    name: 'leaderboardsetting',
	    path: '/setting/leaderboardsetting',
	    component: leaderboardsetting
	}, {
	    name: 'usermanagement',
	    path: '/setting/usermanagement',
	    component: usermanagement
	}, {
	    name: 'directlearning',
	    path: '/setting/directlearning',
	    component: directlearning
	}, {
	    name: 'directlearning_recipient',
	
	    path: '/setting/directlearning/:id/:type',
	    component: directlearning_recipient
	}, {
	    name: 'retest',
	    path: '/setting/campaign',
	    component: campaign
	}, {
	    name: 'email',
	    path: '/setting/email',
	    component: email
	}, {
	    name: 'landing',
	    path: '/setting/landing',
	    component: landing
	}, {
	    name: 'adform',
	    path: '/setting/adform',
	    component: adform
	}, {
	    name: 'listad',
	    path: '/setting/listad',
	    component: listad
	}, {
	    name: 'adlogs',
	    path: '/setting/adlogs/:id',
	    component: adlogs
	}, {
	    name: 'alladlogs',
	    path: '/setting/alladlogs',
	    component: alladlogs
	}, {
	    name: 'oopspage',
	    path: '/setting/oopspage',
	    component: oopspage
	}, {
	    name: 'trainingmail',
	    path: '/setting/trainingmail',
	    component: trainingmail
	}, {
	    name: 'dl_invitation_mail',
	    path: '/setting/dl_invitation_mail',
	    component: dl_invitation_mail
	}, {
	    name: 'dl_login_link_mail',
	    path: '/setting/dl_login_link_mail',
	    component: dl_login_link_mail
	}, {
	    name: 'dl_login_link_mail',
	    path: '/setting/dl_login_link_mail',
	    component: dl_login_link_mail
	}, {
	    name: 'dl_login_with_password_mail',
	    path: '/setting/dl_login_with_password_mail',
	    component: dl_login_with_password_mail
	}, {
	    name: 'security',
	    path: '/setting/security',
	    component: security
	}, {
	    name: 'azure',
	    path: '/setting/azure',
	    component: azure
	}, {
	    name: 'books',
	    path: '/setting/books',
	    component: books
	}, {
	    name: 'changepassword',
	    path: '/setting/changepassword',
	    component: changepassword
	}, {
	    name: 'bulkeducation',
	    path: '/setting/bulkeducation',
	    component: bulkeducation
	}, {
	    name: 'point_configure',
	    path: '/setting/point_configure',
	    component: point_configure
	}, {
	    name: 'reminder',
	    path: '/setting/reminder',
	    component: reminder
	}, {
	    name: 'welcome_mail',
	    path: '/setting/welcome_mail',
	    component: welcome_mail
	}];

/***/ }),

/***/ 624:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(41);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends3 = __webpack_require__(24);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _keys = __webpack_require__(28);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _lodash = __webpack_require__(11);
	
	var _auth = __webpack_require__(206);
	
	var _campaign = __webpack_require__(208);
	
	var _company = __webpack_require__(209);
	
	var _recipient = __webpack_require__(217);
	
	var _bulk_campaign = __webpack_require__(207);
	
	var _dashboard = __webpack_require__(213);
	
	var _report = __webpack_require__(218);
	
	var _setting = __webpack_require__(219);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var vuex = { Auth: _auth.vuex, Company: _company.vuex };
	var keys = (0, _keys2.default)(vuex);
	
	var modules = keys.reduce(function (acc, key) {
	  return (0, _extends4.default)({}, acc, (0, _defineProperty3.default)({}, key, vuex[key].module));
	}, {});
	var plugins = keys.reduce(function (acc, key) {
	  return [].concat((0, _toConsumableArray3.default)(acc), [vuex[key].plugin]);
	}, []).filter(_lodash.isFunction);
	exports.default = { modules: modules, plugins: plugins };

/***/ }),

/***/ 625:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(21);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _moment2 = __webpack_require__(1);
	
	var _moment3 = _interopRequireDefault(_moment2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.mixin({
	    data: function data() {
	        return { loader: false };
	    },
	    methods: {
	        toggleLoader: function toggleLoader() {
	            this.loader = this.loader ? false : true;
	        },
	        moment: function moment() {
	            return _moment3.default.apply(undefined, arguments);
	        }
	    }
	});

/***/ }),

/***/ 626:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends2 = __webpack_require__(24);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vue = __webpack_require__(21);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(6);
	
	var _alerts = __webpack_require__(1048);
	
	var _alerts2 = _interopRequireDefault(_alerts);
	
	var _vueSweetalert = __webpack_require__(1190);
	
	var _vueSweetalert2 = _interopRequireDefault(_vueSweetalert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueSweetalert2.default);
	
	_vue2.default.mixin({
	    components: {
	        Alerts: _alerts2.default
	    },
	    computed: (0, _vuex.mapState)(['messages', 'fetching']),
	    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['setMessage', 'resetMessages']), {
	        updateErrors: function updateErrors($response) {
	
	            var backendErrors = $response.response.data.errors;
	
	            for (var index in backendErrors) {
	                this.errors.add(index, backendErrors[index][0]);
	            }
	        }
	    })
	});

/***/ }),

/***/ 627:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(908);

/***/ }),

/***/ 628:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperties = __webpack_require__(639);
	
	var _defineProperties2 = _interopRequireDefault(_defineProperties);
	
	exports.default = install;
	
	var _vue = __webpack_require__(21);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var bus = new _vue2.default();
	
	function install(Vue) {
	  (0, _defineProperties2.default)(Vue.prototype, {
	    $bus: {
	      get: function get() {
	        return bus;
	      }
	    }
	  });
	}

/***/ }),

/***/ 629:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof2 = __webpack_require__(44);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _promise = __webpack_require__(36);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _lodash = __webpack_require__(11);
	
	var _services = __webpack_require__(142);
	
	var services = _interopRequireWildcard(_services);
	
	var _index = __webpack_require__(5);
	
	var _config = __webpack_require__(4);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var lmsBounceInProgress = false;
	
	exports.default = function (http, store, router) {
	    http.interceptors.request.use(function (config) {
	
	        if (!config.hideLoader) {
	            $('.pace').removeClass('pace-inactive');
	            $('.pace').addClass('pace-active');
	        }
	
	        if (typeof window !== 'undefined' && window.location) {
	            var currentPath = window.location.pathname || '/';
	            var fullUrl = window.location.origin + currentPath;
	
	            if (config.headers && typeof config.headers.set === 'function') {
	                config.headers.set('X-Page-URL', fullUrl);
	            } else if (config.headers) {
	                config.headers['X-Page-URL'] = fullUrl;
	            } else {
	                config.headers = { 'X-Page-URL': fullUrl };
	            }
	        }
	
	        store.dispatch('setFetching', { fetching: true });
	
	        return config;
	    }, function (error) {
	        return _promise2.default.reject(error);
	    }), http.interceptors.response.use(function (response) {
	        if (!response.config.hideLoader) {
	            $('.pace').removeClass('pace-active');
	            $('.pace').addClass('pace-inactive');
	        }
	
	        store.dispatch('setFetching', { fetching: false });
	
	        return response;
	    }, function (error) {
	
	        if (!error.config.hideLoader) {
	            $('.pace').removeClass('pace-active');
	            $('.pace').addClass('pace-inactive');
	        }
	
	        var response = error.response;
	
	        if (response.status == 401 && !lmsBounceInProgress) {
	            lmsBounceInProgress = true;
	
	            var base = _config.appUrl.replace(/\/$/, '');
	            var lmsTarget = window.location.pathname + window.location.search;
	
	            try {
	                console.log('[LMS-SSO-DEBUG] clientv2 401', {
	                    requestUrl: error.config && error.config.url,
	                    pathname: window.location.pathname,
	                    search: window.location.search,
	                    lmsTarget: lmsTarget,
	                    appUrl: _config.appUrl,
	                    bounces: sessionStorage.getItem('lms_sso_bounces')
	                });
	            } catch (e) {}
	
	            var bounces = parseInt(sessionStorage.getItem('lms_sso_bounces') || '0', 10) + 1;
	            if (bounces > 3) {
	                sessionStorage.removeItem('lms_sso_bounces');
	                try {
	                    console.log('[LMS-SSO-DEBUG] clientv2 -> LOGOUT (loop-breaker)');
	                } catch (e) {}
	                window.location = base + '/logout';
	            } else {
	                sessionStorage.setItem('lms_sso_bounces', String(bounces));
	                var bounceUrl = base + '/lms-sso?redirect=' + encodeURIComponent(lmsTarget);
	                try {
	                    console.log('[LMS-SSO-DEBUG] clientv2 -> bounce', bounceUrl);
	                } catch (e) {}
	                window.location = bounceUrl;
	            }
	        }
	
	        store.dispatch('resetMessages');
	
	        if (response.data.errors && (0, _typeof3.default)(response.data.errors) === 'object') {
	            store.dispatch('setMessage', { type: 'error', message: response.data.errors });
	        } else {
	            if (response.data.message) {
	                store.dispatch('setMessage', { type: 'warning', message: response.data.message });
	            }
	        }
	
	        store.dispatch('setFetching', { fetching: false });
	
	        return _promise2.default.reject(error);
	    });
	};

/***/ }),

/***/ 630:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _store = __webpack_require__(220);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _config = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var beforeEach = function beforeEach(to, from, next) {
	    var auth = to.meta.requiresAuth == undefined;
	    window.scrollTo(0, 0);
	
	    _store2.default.dispatch('resetMessages');
	
	    if (auth !== true) {
	        next();
	        return;
	    }
	
	    var lmsUser = null;
	    try {
	        lmsUser = JSON.parse(localStorage.getItem('user'));
	    } catch (e) {
	        lmsUser = null;
	    }
	    if (!lmsUser) {
	        var base = (_config.appUrl || '').replace(/\/$/, '');
	        var target = to.fullPath || to.path || '';
	        window.location = base + '/lms-sso?redirect=' + encodeURIComponent(target);
	        return;
	    }
	
	    next();
	};
	
	exports.default = beforeEach;

/***/ }),

/***/ 631:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(41);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _vue = __webpack_require__(21);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _auth = __webpack_require__(1047);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _main = __webpack_require__(1049);
	
	var _main2 = _interopRequireDefault(_main);
	
	var _vueRouter = __webpack_require__(1188);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _beforeEach = __webpack_require__(630);
	
	var _beforeEach2 = _interopRequireDefault(_beforeEach);
	
	var _auth3 = __webpack_require__(206);
	
	var _app = __webpack_require__(145);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	
	var routes = [{
	    name: 'auth',
	    path: '/auth',
	    component: _auth2.default,
	    meta: { requiresAuth: false },
	    children: [].concat((0, _toConsumableArray3.default)(_auth3.routes)),
	    redirect: { name: 'auth.login' }
	}, {
	    path: '/',
	    component: _main2.default,
	    meta: { requiresAuth: true },
	    children: [].concat((0, _toConsumableArray3.default)(_app.routes)),
	    redirect: { name: 'dashboard.index' }
	}, {
	    name: 'catchall',
	    path: '*',
	    redirect: { name: 'dashboard.index' }
	}];
	
	var router = new _vueRouter2.default({
	    routes: routes,
	    linkActiveClass: 'active',
	    mode: 'history' });
	
	router.beforeEach(_beforeEach2.default);
	
	exports.default = router;

/***/ }),

/***/ 632:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _types = __webpack_require__(221);
	
	var TYPES = _interopRequireWildcard(_types);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = {
	    setFetching: function setFetching(_ref, obj) {
	        var commit = _ref.commit;
	
	        commit(TYPES.MAIN_SET_FETCHING, obj);
	    },
	    setMessage: function setMessage(_ref2, obj) {
	        var commit = _ref2.commit;
	
	        commit(TYPES.MAIN_SET_MESSAGE, obj);
	    },
	    resetMessages: function resetMessages(_ref3) {
	        var commit = _ref3.commit;
	
	        commit(TYPES.MAIN_SET_MESSAGE, { type: 'success', message: '' });
	        commit(TYPES.MAIN_SET_MESSAGE, { type: 'error', message: {} });
	        commit(TYPES.MAIN_SET_MESSAGE, { type: 'warning', message: '' });
	        commit(TYPES.MAIN_SET_MESSAGE, { type: 'validation', message: {} });
	    }
	};

/***/ }),

/***/ 633:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var isAuthPage = exports.isAuthPage = function isAuthPage(_ref) {
	    var route = _ref.route;
	
	    if (route.path.indexOf('/auth') !== -1) return true;
	
	    if (route.path.indexOf('/login') !== -1) return true;
	
	    if (route.path.indexOf('/register') !== -1) return true;
	
	    if (route.path.indexOf('/reset/') !== -1) return true;
	
	    if (route.path.indexOf('/verification') !== -1) return true;
	
	    return false;
	};
	
	var shouldShowNavigation = exports.shouldShowNavigation = function shouldShowNavigation(_ref2, getters) {
	    var route = _ref2.route;
	    return route.path ? !getters.isAuthPage : false;
	};

/***/ }),

/***/ 634:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(24);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _app = __webpack_require__(145);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _extends3.default)({}, _app.vuex.modules);

/***/ }),

/***/ 635:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _TYPES$MAIN_SET_FETCH;
	
	var _types = __webpack_require__(221);
	
	var TYPES = _interopRequireWildcard(_types);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (_TYPES$MAIN_SET_FETCH = {}, (0, _defineProperty3.default)(_TYPES$MAIN_SET_FETCH, TYPES.MAIN_SET_FETCHING, function (state, obj) {
	  state.fetching = obj.fetching;
	}), (0, _defineProperty3.default)(_TYPES$MAIN_SET_FETCH, TYPES.MAIN_SET_MESSAGE, function (state, obj) {
	  state.messages[obj.type] = obj.message;
	}), _TYPES$MAIN_SET_FETCH);

/***/ }),

/***/ 636:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(41);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _app = __webpack_require__(145);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = [].concat((0, _toConsumableArray3.default)(_app.vuex.plugins));

/***/ }),

/***/ 818:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 864:
/***/ (function(module, exports) {

	module.exports = {"login":{"heading":{"login":"Login","forgot_password":"Forgot Password"},"humans_are_the_weakest_link":"Humans are the weakest link in Cyber Security.","now_make_it_the_strongest":"Now make it the strongest by deploying the HumanFirewall.","last_year_the_threat":"LAST YEAR THREAT VIA PHISHING ATTACKS INCREASED BY 400%!","email":"EMAIL","password":"PASSWORD","keep_me_logged_in":"Keep Me Logged In","forgot_password":"Forgot password?","error":"Error!","login":"Login","learning_login":"Request for Password","start_a_free_trial":"Start A Free Trial","email_address":"Email Address","please_check_your_email_password_reset":"Please check your email for instructions to reset your password.","reset_password":"Send Reset Instructions","back_to_login":"Back to Login","success":"Success: ","already_registered_with_us":"If you have already registered with us, you will receive an email with password reset instructions shortly.","your_registered_email_address":"Your registered email address","your_super_secret_password":"Your password","please_enter_your_email_here":"Please enter your email address"},"register":{"start_a_free_trial":"Register for Free Trial","register_secure_organization":"Register & Secure your organization against phishing.","your_first_name":"Your First name","your_last_name":"Your Last Name","your_job_title":"Your Job Title","your_organisation":"Organization Name","number_of_employee":"Number of Employees","country":"Country","timezone":"Time Zone","lets_setup_your_account":"Let's setup your account credentials","email":"Email","password":"Password","re_type_password":"Confirm Password","i_agree":"By signing up, you agree to our ","terms":"Terms of Service ","and":"and ","policy":"Privacy Policy.","create_a_new_account":"Create a new account","if_you_already_account":"If you already have an account","sign_in":"Login here","please_enter_your_first_name_here":"Please enter your first name","please_enter_your_last_name_here":"Please enter your last name","please_enter_your_job_title_here":"Please enter your job title","your_company_or_brand_name":"Your Company or Brand name","you_can_also_enter_a_guessed_value":"Please enter the number of employees","your_residence_country":"Your country","please_enter_your_email_here":"Please enter your email","please_enter_your_password_here":"Please enter your password","Please_re_type_your_password_here":"Please re-enter your password","domain_already_verified":"This domain is already verified and cannot be used again."},"verification":{"two_factor_authentication":"Two factor authentication","please_scan_this_qr_Code_image":"Please scan this QR Code in Google Authenticator App on your phone and enter the code generated.","please_enter_the_code_generated":"Please enter the code generated by Google Authenticator App.","you_can_download":"You can download the app for","ios_here":"iOS here","and_for":"and for ","android_here":"Android here","verification_code":"Verification code","activate_2fa_now":"Activate 2FA Now","skip_setup_2fa_later":"Skip & Setup 2FA Later","verify_proceed":"Verify & Proceed","please_enter_your_verification_code_here":"Please enter your verification code here.","something_went_wrong":"OOPS!! It seems something is not right!! Please try again."},"forgotpassword":{"new_password":"New Password","confirm_password":"Confirm Password","submit":"Submit","cancel":"Cancel","please_enter_your_password_here":"Please enter your password","please_re_type_your_password here":"Please re-enter your password"}}

/***/ }),

/***/ 865:
/***/ (function(module, exports) {

	module.exports = {"import":{"name_not_entered":"Please enter file name.","file_not_selected":"Please select a file."},"description":{"title_1":"Title","title_2":"title","description":"Description","proceed":"PROCEED","example_header":"Example:","example":{"title_header":"Example: {campaign} Title","title":"Phishing Training- Level 1 users - Finance Team","description_header":"Example: {campaign} Description","description":"This {campaign} is meant to train users to recognise Phishing emails by using URL recognition, specifically identifying the primary domain.","note":"Giving a unique name to your {campaign} will help you identify which email you sent, to which set of users and what was the objective of the campaign. "},"copyright":"Copyright &copy;","humanFirewall":"HumanFirewall","tm":"TM","all_rights_reserved":"All rights reserved.","www_humanfirewall":"www.humanfirewall.io"},"education":{"you_can_skip":"You can Skip this step.","skip_this_step":"Skip this step","learning":"Learning","super_hign_risk":"Super High Risks","basic_portlet_tools":"Basic Portlet tools include a slide toggle button ,refresh button  and a close button. All these are fully customizable and come with callback functions to integrate with your code. Clicking on the refresh button will simulate an AJAX call.","preview":"Preview","use_this":"Use This"},"email":{"please_select_any_recipient":"Please select Recipients for this {campaign}","please_select_atleast_recipient":"Please select at least one sheet.","sender_name":"Sender Name","email_subject":"Subject of the mail","sender":"Sender","email_domain":"Email Domain","please_select_a_domain_name":"Please select a domain name","personalise_subject_email":"You can personalise subject & email by adding custom tags","click_here_to_see_complete_list":"Click here to see the complete list of available tags","flag_email_as_urgent":"Flag email as urgent to get more attention from recipients","attachment_name":"Attachment Name","attachment_type":"Attachment Type","adobe_pdf":"Adobe PDF (.pdf)","microsoft_word":"Microsoft Word (.doc)","microsoft_excel":"Microsoft Excel (.xls)","preview_email_in_a_new_tab":"Preview email in a new tab","send_a_preview_email":"Send a test email","save_and_proceed":"SAVE AND PROCEED","send_test_email":"Send Test Email","name":"name","email":"Email","cancel":"Cancel","add_one_more_tester":"Add another email?","send_test_emails":"Send Test mail","select_recipients":"Select Recipients","a_make_believe_from_name":"Please enter sender's name","pick_a_domain_name_from_list":"Choose a domain name from the list","name_your_attachment_file":"Choose a name for your attachment ","email_sender_error":"Space is not allowed in sender","required":"Required"},"sms":{"from_name":"From Name","template":"Sms Template","preview_email_in_a_new_tab":"Preview SMS in a new tab"},"landing":{"you_can_skip_this_step":"You can skip this step.","skip_this_step":"SKIP THIS STEP","specify_landing_url":"Specify Landing URL","subdomain":"Subdomain","domain_name":"Domain Name","please_select_any_domain_name":"Please select a Domain Name","subdirectory_file":"Subdirectory / File","landing_content":"Landing Content","edit_landing_page":"Edit landing page","preview_in_a_new_tab":"Preview in a new tab","save_and_proceed":"SAVE AND PROCEED","a_make_believe_subdomain_name":"Please enter a subdomain name","pick_a_domain_name_from_list":"Choose a domain name from the list","a_make_believe_sub_directory_name":"Please enter a sub directory name"},"schedule":{"send_on":"Send On :","send_between":"Send Between","to":"to","send_count_per_day":"Send Count (per day)","how_long_do_you_want_scenario_active":"How long do you want this campaign to stay active?","how_long_do_you_want_announcement_active":"How long do you want this Announcement to stay active?","explain":"(explain)","your_scenario_content_tracking_active":"Your campaign's content and tracking will be available as long as your campaign is active.","while_we_typically_suggest_keeping_scenarios":"While we recommend keeping campaigns active for 5 to 7 days, we can accommodate as little as 1 day and as many as 30 days should your needs vary.","while_we_typically_suggest_keeping_announcement":"While we recommend keeping Announcement active for 5 to 7 days, we can accommodate as little as 1 day and as many as 30 days should your needs vary.","ok":"OK","please_select_one":"Please select one","total_number_of_recipients":"Total Number of recipients","i_agree_to_the":"I agree to the","terms_and_conditions":"terms & conditions","receive_daily_scenario":"Receive daily summary via email","receive_pdf_summary_report":"Receive PDF summary report","please_have_a_support1":"Please have a support professional review this scenario. NOTE: We will need atleast one full business day. We may need more time depending upon","please_have_a_support2":"your support plan! ","send_a_test_mail":"Send a Test Mail","send_a_test_campaign":"Send a Test Campaign","send_a_test_announcement":"Send a Test Announcement","email_summary":"E-mail Summary","send":"Send","action":"Action","now":"Now","schedule":"REVIEW & SCHEDULE","send_test_email":"Send Test Email","send_a_test_sms":"Send Test Message","name_1":"Name","email":"Email","sms":"Sms","phone":"Phone","name_2":"Name","cancel":"Cancel","add_one_more_tester":"Add another email?","add_one_more_sms_tester":"Add another SMS?","send_test_emails":"Send Test Email","send_test_sms":"Send Test SMS","auto_reminder_message":"Auto Reminder for mandatory training to be sent to people who"},"create":{"super_high_risk":"SUPER HIGH RISK","level":"Level","use_this":"Use This","preview":"Preview","filters_1":"FILTERS","filters_2":"Filters","method":"Method","data_entry":"Data Entry","attachment":"Attachment","click":"Click","announcement":"Announcement","levels":"Levels","level_1":"Level 1","level_2":"Level 2","level_3":"Level 3","level_4":"Level 4","level_5":"Level 5","apply":"Apply","close":"Close","motivator":"Motivator","general":"General","category":"Category","no_scenario":"No scenario found.","type":{"campaign_type":"Campaign Type","email":"Email","sms":"SMS"}},"index1":{"launch_a_new":" Add","prepare_your_organisation":"Create a new phishing attack simulation campaign ","prepare_your_organisation_announcement":"Create a new announcement ","pick_a_scenario":"Choose a Scenario","title_description":"Title & Description","email":"Email","sms":"Sms","landing_page":"Landing Page","education":"Education","schedule_publish":"Schedule","cancel":"Cancel"},"index2":{"back_to_campaigns":"Back to Campaigns","back_to_announcements":"Back to Announcements","manage":"Manage","no_recipient_added":"You have not added a recipient yet:","add_recipients":"Add Recipients","launch_a_new":"Launch A New Campaign","launch_a_new_announcement":"Launch A New Announcement","draft":"Draft","you_have":"You have","ending_soon":"ending soon","launched_on":"STARTS","launched_for":"ENDS","title":"Title","description":"Description","email_sent":"Email Sent","sent":"Sent","channel":"Channel","opened":"Opened","clicked":"Clicked","submitted":"Submitted","compromised":"Compromised","acknowledged":"Acknowledged","trained":"Trained","level":"Level","status":"Status","edit":"Edit","no":"No","launched_yet":"launched yet.","found":"Found.","live":"Live","past":"Past","you_have_launched":"You have launched","in_total":"in total","recipient_count":"Recipients","before_loading":"Please wait while your campaigns load","before_loading_announcement":"Please wait while your announcements load"},"test_mail":{"error_in_test_mail":"Error in sending test mail.","error_in_test_sms":"Error in sending test message.","success_in_test_mail":"Test mail sent successfully.","success_in_test_sms":"Test message sent successfully."},"bulk_campaign":{"error_in_date_conflict":"Campaign dates are confliciting.Please check and update dates.","error_early_schedule":"You cannot schedule campaigns within 1 hours of current time. Please reschedule the campaign","only_announcement_message":"You can select only announcements"},"scenario":{"before_loading":"Please wait while your scenarios load","file_select_error":"Please select thumbnail image."}}

/***/ }),

/***/ 866:
/***/ (function(module, exports) {

	module.exports = {"index":{"add":"Add","add_new_domain":"Add New Domain","action":"Action","create_new_domain":"Please enter the name of your domain.","click_on_download_button":"Download the TXT file by clicking on the download button. You can upload the file using your preferred FTP client.","click_on_verify_button":"Then click on the verify button","close":"Close","domain_name":"Domain Name","domain_link":"Domain URL","domain":"Domain","download":"Download","domains_1":"Domains","domains_2":"domains.","domain_verification_steps":"Domain Verification Steps","enter_your_domain":"Enter your Domain details.","entries":"entries","home":"Home","new":"Add New","of":"of","step_1":"Step:1","step_2":"Step:2","step_3":"Step:3","showing":"Showing","sr_no":"Sr. No.","you_have_added":"You have added","verification_status":"Verification Status","1_to":"1 to","name_of_your_domain":"Domain Name","example_www_yourdomain_com":"Example: www.yourdomain.com"}}

/***/ }),

/***/ 867:
/***/ (function(module, exports) {

	module.exports = {"leaderboard":{"add_recipient_1st":"add recipient","department":"Department","designation":"Designation","email":"Email","filter_by_loction":"Filter by loction","filter_by_department":"Filter by Department","filter_by_designation":"Filter by Designation","name":"Name","import_recipients":"Import Recipients","last_name":"Last Name","location":"Location","no_recipient":"No Recipient","leader_1":"Leaderboard","recipients_2":"recipients","recipient":"recipient","registered_with_us":"registered with us.","s_no":"Sr.no","to_run_phishing_before_text":"Please","to_run_phishing_after_text":"before running Phishing, Simulation or Announcements.","you_have":"You have","search":"Search","by_location":"By Location","by_department":"By Department","by_designation":"By Designation","error_on_location":"Please enter your location","error_on_designation":"Please enter your designation","error_on_department":"Please enter your department","error_on_sheet":"Please enter a name for the sheet","action":"Action","total_score":"Total Score","domain_verify":"Please verify your domain before uploading the recipient list."},"import":{"add":"Add","action":"Action","close":"Close","download":"Download","download_sample_sheet":"Download sample sheet","imported_sheets":"View Recipents Lists","import_new_sheet":"Import New Sheet","imported_by":"Imported By","imported_on":"Imported On","in_total":"in total","import_sheet":"Import Sheet","import_your_sheet":"Import your sheet","name":"name","no_sheet":"no sheet","please_download_sample_sheet":"Please download the sample sheet before uploading. Please ensure that you do not remove the headers.","recipients_count":"Add Count","recipients_update_count":"Update Count","sheet":"sheet","sheets":"sheets","sheet_name":"Sheet Name","status":"Status","you_have_imported":"You have imported","name_of_sheet":"Name of sheet"},"edit":{"action":"Action","campaign_name":"Campaign Name","cancel":"Cancel","designation":"Designation","department":"Department","edit":"Edit","email_id":"Email ID","export":"Export","export_as_pdf":"Export as PDF","export_as_excel":"Export as Excel","export_as_csv":"Export as CSV","edit_user_information":"Edit User Information","first_name":"First Name","filter_by_date":"Filter by date","id":"Id","location":"Location","last_name":"Last Name","phone_no":"Phone No.","report_list":"Report List","submit":"Submit","time_in_gmt":"Time","no_results":"No results found.","search":"Search","pick_a_date":"Pick a date","clicked":"Clicked","report":"Report","trained":"Trained","compromised":"Compromised","total":"Total"}}

/***/ }),

/***/ 868:
/***/ (function(module, exports) {

	module.exports = {"recipient":{"add_recipient_1st":"add recipient","department":"Department","designation":"Designation","email":"Email","filter_by_loction":"Filter by loction","filter_by_department":"Filter by Department","filter_by_designation":"Filter by Designation","first_name":"First Name","import_recipients":"Import Recipients","last_name":"Last Name","location":"Location","no_recipient":"No Recipient","recipients_1":"Recipients","recipients_2":"recipients","recipient":"recipient","registered_with_us":"registered with us.","s_no":"S.no","to_run_phishing_before_text":"Please","to_run_phishing_after_text":"before running Phishing, Simulation or Announcements.","you_have":"You have","search":"Search","by_location":"By Location","by_department":"By Department","by_designation":"By Designation","error_on_location":"Please enter your location","error_on_designation":"Please enter your designation","error_on_department":"Please enter your department","error_on_sheet":"Please enter a name for the sheet","action":"Action","domain_verify":"Please verify your domain before uploading the recipient list."},"import":{"add":"Next","action":"Action","close":"Close","download":"Download","download_sample_sheet":"Download sample sheet","imported_sheets":"View Recipents Lists","import_new_sheet":"Import New Sheet","imported_by":"Imported By","imported_on":"Imported On","in_total":"in total","import_sheet":"Import Sheet","import_your_sheet":"Import your sheet","name":"name","no_sheet":"no sheet","please_download_sample_sheet":"Please download the sample sheet before uploading. Please ensure that you do not remove the headers.","recipients_count":"Add Count","recipients_update_count":"Update Count","sheet":"sheet","sheets":"sheets","sheet_name":"Sheet Name","status":"Status","you_have_imported":"You have imported","name_of_sheet":"Name of sheet"},"edit":{"action":"Action","campaign_name":"Campaign Name","cancel":"Cancel","designation":"Designation","department":"Department","edit":"Edit","email_id":"Email ID","export":"Export","export_as_pdf":"Export as PDF","export_as_excel":"Export as Excel","export_as_csv":"Export as CSV","edit_user_information":"Edit User Information","first_name":"First Name","filter_by_date":"Filter by date","id":"Id","location":"Location","last_name":"Last Name","phone_no":"Phone No.","report_list":"Report List","submit":"Submit","time_in_gmt":"Time","no_results":"No results found.","search":"Search","pick_a_date":"Pick a date"}}

/***/ }),

/***/ 869:
/***/ (function(module, exports) {

	module.exports = {"campaignreporting":{"campaigns":"Campaigns","filter_by_date":"Filter by date","export":"Export","export_as_pdf":"Export as PDF","export_as_excel":"Export as Excel","export_as_csv":"Export as CSV","date":"Date","sent":"Sent","open":"Open","click":"Click","compromise":"Compromise","learning":"Learning","pick_a_date":"Select a date"},"recipientlisting":{"export":"Export","filter_by_date":"Filter by date","export_as_pdf":"Export as PDF","export_as_excel":"Export as Excel","export_as_csv":"Export as CSV","id":"Id","recipient_name":"Recipient Name","recipient_email":"Recipient Email","department":"Department","location":"Location","action":"Action","view_log":"View Log","search":"Search","pick_a_date":"Select a date"},"repeataffender":{"campaigns_report":"Campaigns Report","campaign_type":"Campaign Type","camapigns":"Camapigns","repeat_offenders":"Repeat Offenders","not_tested_yet":"Not Tested Yet","hi_3":"hi 3","campaigns_reporting":"Campaigns Reporting.","filter_by_status":"Filter by Status","sr_no":"Sr. No","title_description":"Title / Description","started":"Started","open":"Open","click":"Click","status":"Status","search":"Search","select_campaign":"Select Campaign"},"reporting":{"campaigns_report":"Campaigns Report","campaign_type":"Campaign Type","camapigns":"Camapigns","repeat_offenders":"Repeat Offenders","not_tested_yet":"Not Tested Yet","hi_3":"hi 3","campaigns_reporting":"Campaigns Reporting..","filter_by_status":"Filter by Status","sr_no":"Sr. No","title_description":"Title / Description","started":"Started","sent":"Sent","open":"Open","click":"Click","compromise":"Compromise","learning":"Learning","status":"Status","search":"Search","select_campaign":"Select Campaign"}}

/***/ }),

/***/ 917:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(452)
	
	/* template */
	var __vue_template__ = __webpack_require__(1176)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 1047:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(581)
	
	/* template */
	var __vue_template__ = __webpack_require__(1136)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 1048:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(818)
	
	/* script */
	__vue_exports__ = __webpack_require__(582)
	
	/* template */
	var __vue_template__ = __webpack_require__(1107)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-35412869"
	
	module.exports = __vue_exports__


/***/ }),

/***/ 1049:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(583)
	
	/* template */
	var __vue_template__ = __webpack_require__(1061)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 1050:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(584)
	
	/* template */
	var __vue_template__ = __webpack_require__(1096)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 1051:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(585)
	
	/* template */
	var __vue_template__ = __webpack_require__(1169)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 1061:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('side-bar', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.shouldShowNavigation),
	      expression: "shouldShowNavigation"
	    }]
	  }), _vm._v(" "), _c('div', {
	    staticClass: "page-container"
	  }, [_c('nav-bar', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.shouldShowNavigation),
	      expression: "shouldShowNavigation"
	    }]
	  }), _vm._v(" "), _c('router-view', {
	    key: _vm.$route.fullPath
	  })], 1)], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 1096:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "header"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "in_mobile"
	  }, [_c('div', {
	    staticClass: "brand inline d-none d-lg-block d-xl-block"
	  }, [(_vm.company_logo) ? _c('img', {
	    staticClass: "logo_c",
	    attrs: {
	      "src": _vm.company_logo,
	      "alt": "logo",
	      "data-src": _vm.company_logo,
	      "data-src-retina": _vm.company_logo,
	      "width": "180px"
	    }
	  }) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "d-flex align-items-center"
	  }, [_vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "dropdown pull-right d-lg-block"
	  }, [_c('button', {
	    staticClass: "profile-dropdown-toggle logindetail_p",
	    attrs: {
	      "type": "button",
	      "data-toggle": "dropdown",
	      "aria-haspopup": "true",
	      "aria-expanded": "false",
	      "aria-label": "profile dropdown"
	    }
	  }, [_c('div', {
	    staticClass: "logindetail"
	  }, [_c('span', [_vm._v(_vm._s(_vm.user.first_name) + " " + _vm._s(_vm.user.last_name))]), _vm._v(" "), _c('span', [_vm._v("(" + _vm._s(_vm.user.company) + ")")])]), _vm._v(" "), _c('span', {
	    staticClass: "thumbnail-wrapper d32 circular inline",
	    staticStyle: {
	      "background-image": "url('/static/assets/img/user.svg')"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "dropdown-menu dropdown-menu-right profile-dropdown",
	    attrs: {
	      "role": "menu"
	    }
	  }, [_c('a', {
	    staticClass: "pull-left",
	    staticStyle: {
	      "cursor": "pointer"
	    },
	    on: {
	      "click": function($event) {
	        _vm.logoutUser()
	      }
	    }
	  }, [_vm._v("Logout")]), _vm._v(" "), _c('div', {
	    staticClass: "dropdown-divider"
	  })])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    staticClass: "hamburger"
	  }, [_c('i', {
	    staticClass: "fas fa-bars"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "theme_change  btn-icon-link",
	    staticStyle: {
	      "display": "none"
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-sun"
	  }), _c('i', {
	    staticClass: "far fa-moon"
	  })])
	}]}

/***/ }),

/***/ 1107:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "alerts"
	  }, [_c('el-alert', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.hasSuccessMessage),
	      expression: "hasSuccessMessage"
	    }],
	    attrs: {
	      "title": _vm.messages.success,
	      "type": "success",
	      "show-icon": ""
	    },
	    on: {
	      "close": function($event) {
	        _vm.dismiss('success')
	      }
	    }
	  }), _vm._v(" "), _c('el-alert', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.hasErrorMessages),
	      expression: "hasErrorMessages"
	    }],
	    attrs: {
	      "title": _vm.formatedErrorMessage,
	      "type": "error",
	      "show-icon": ""
	    },
	    on: {
	      "close": function($event) {
	        _vm.dismiss('error')
	      }
	    }
	  }), _vm._v(" "), _c('el-alert', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.hasValidationMessages),
	      expression: "hasValidationMessages"
	    }],
	    attrs: {
	      "title": _vm.formatedValidationMessage,
	      "type": "warning",
	      "show-icon": ""
	    },
	    on: {
	      "close": function($event) {
	        _vm.dismiss('validation')
	      }
	    }
	  }), _vm._v(" "), _c('el-alert', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.hasWarningMessages),
	      expression: "hasWarningMessages"
	    }],
	    attrs: {
	      "title": _vm.messages.warning,
	      "type": "warning",
	      "show-icon": ""
	    },
	    on: {
	      "close": function($event) {
	        _vm.dismiss('validation')
	      }
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 1136:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {}, [_c('router-view')], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 1169:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('nav', {
	    staticClass: "page-sidebar",
	    attrs: {
	      "data-pages": "sidebar"
	    }
	  }, [_c('div', {
	    staticClass: "sidebar-menu"
	  }, [_c('ul', {
	    staticClass: "menu-items"
	  }, [_c('li', {
	    staticClass: "open active padtopbottom"
	  }, [_vm._m(0), _vm._v(" "), _c('ul', {
	    staticClass: "sub-menu"
	  }, [_c('li', {
	    staticClass: "hide_after_click"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'lms.courses'
	      }
	    }
	  }, [_vm._v("Courses")]), _vm._v(" "), _vm._m(1)], 1), _vm._v(" "), _c('li', {
	    staticClass: "hide_after_click"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'lms.reports'
	      }
	    }
	  }, [_vm._v("Reports")]), _vm._v(" "), _vm._m(2)], 1), _vm._v(" "), _c('li', {
	    staticClass: "hide_after_click"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'lms.setting'
	      }
	    }
	  }, [_vm._v("Settings")]), _vm._v(" "), _vm._m(3)], 1), _vm._v(" "), _c('li', {
	    staticClass: "hide_after_click"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'lms.emaillogs'
	      }
	    }
	  }, [_vm._v("Logs")]), _vm._v(" "), _vm._m(4)], 1), _vm._v(" "), _c('li', {
	    staticClass: "hide_after_click"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'lms.learningpath'
	      }
	    }
	  }, [_vm._v("Learning Path")]), _vm._v(" "), _vm._m(5)], 1), _vm._v(" "), (_vm.canApproveWorkspace) ? _c('li', {
	    staticClass: "hide_after_click"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'lms.approvals'
	      }
	    }
	  }, [_vm._v("Approvers Workspace")]), _vm._v(" "), _vm._m(6)], 1) : _vm._e(), _vm._v(" "), (_vm.canCreateWorkspace) ? _c('li', {
	    staticClass: "hide_after_click"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'lms.creatorapprovals'
	      }
	    }
	  }, [_vm._v("Creators Workspace")]), _vm._v(" "), _vm._m(7)], 1) : _vm._e()])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "lmsSidebarHeader"
	  }, [_c('span', {
	    staticClass: "title"
	  }, [_vm._v("LMS")]), _vm._v(" "), _c('div', {
	    staticClass: "sidebarCollapse",
	    attrs: {
	      "aria-label": "Pin Menu",
	      "type": "button"
	    }
	  }, [_c('i', {
	    staticClass: "pg-icon"
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_c('i', {
	    staticClass: "fas fa-book"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_c('i', {
	    staticClass: "fas fa-file-alt"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_c('i', {
	    staticClass: "fas fa-cog"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_c('i', {
	    staticClass: "fas fa-clipboard-list"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_c('i', {
	    staticClass: "fa fa-user-graduate"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_c('i', {
	    staticClass: "fas fa-clipboard-check"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_c('i', {
	    staticClass: "fas fa-user-edit"
	  })])
	}]}

/***/ }),

/***/ 1176:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('router-view', {
	    key: _vm.$route.fullPath
	  })], 1)
	},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/app.078d4056379dd2ad048b.js